<template>
  <div class="content">
    <div class="order-sticky-scroll">
      <div>
        <validation-observer ref="observer" method="post">
          <Navi
            class="order-sticky"
            tab-id="2"
            :form="form"
            @back="handleBackButtonClick"
            :mode="naviMode"
          />

          <h2 id="syaryo-top" class="page-title">車両情報入力</h2>

          <h4 v-if="isIrekae" class="page-sub-title pl-2 pl-md-4 mt-4 mt-md-5">
            下取/入れ替え車両 納車先
          </h4>
          <div v-if="isIrekae" class="section-wrapper">
            <section class="irekae-nosya">
              <table class="table">
                <tr>
                  <th>名称</th>
                  <td>
                    <div class="row">
                      <span class="mx-4">{{ nosya.MEI }}</span>
                      <button
                        type="button"
                        class="btn btn-success bold"
                        style="height: 40px"
                        @click="isShowIrekaeNosyaDialog = true"
                      >
                        納車先を変更
                      </button>
                    </div>
                  </td>
                </tr>
                <tr v-if="nosya.TODO_MEI || nosya.SHIKU_MEI || nosya.BANCHI">
                  <th><span>住所</span></th>
                  <td>
                    <span>
                      <span v-if="nosya.YUBIN1 && nosya.YUBIN2">
                        {{ nosya.YUBIN1 }}-{{ nosya.YUBIN2 }}
                        <br />
                      </span>
                      {{ nosya.TODO_MEI }}{{ nosya.SHIKU_MEI
                      }}{{ nosya.BANCHI }}
                    </span>
                  </td>
                </tr>
                <tr v-if="this.isNosyaDirect || nosya.TEL">
                  <th><span>TEL</span></th>
                  <td>
                    <span>{{ nosya.TEL }}</span>
                  </td>
                </tr>
                <tr
                  v-if="
                    this.isNosyaDirect ||
                    (!nosya.IS_MASTER_ACTIVE && nosya.TANTO_MEI)
                  "
                >
                  <th><span>担当者名</span></th>
                  <td>
                    <span>{{ nosya.TANTO_MEI }}</span>
                  </td>
                </tr>
                <tr v-if="this.isNosyaDirect || nosya.TANTO_TEL">
                  <th><span>担当者TEL</span></th>
                  <td>
                    <span>{{ nosya.TANTO_TEL }}</span>
                  </td>
                </tr>
                <tr v-if="this.isNosyaDirect || nosya.YUSO_KBN">
                  <th><span>種別</span></th>
                  <td>
                    <span>{{ getText(yusoKbnList, nosya.YUSO_KBN) }}</span>
                  </td>
                </tr>
                <tr v-if="this.isNosyaDirect || nosya.TEIKYU_BI">
                  <th><span>定休日</span></th>
                  <td>
                    <span>
                      {{
                        Array.isArray(nosya.TEIKYU_BI)
                          ? nosya.TEIKYU_BI.join(',')
                          : nosya.TEIKYU_BI
                      }}
                    </span>
                  </td>
                </tr>
                <tr
                  v-if="
                    this.isNosyaDirect ||
                    nosya.EIGYO_KAISI_JIKAN ||
                    nosya.EIGYO_SYURYO_JIKAN
                  "
                >
                  <th><span>営業時間</span></th>
                  <td>
                    <span>
                      {{ nosya.EIGYO_KAISI_JIKAN }}
                      <span
                        v-if="
                          nosya.EIGYO_KAISI_JIKAN || nosya.EIGYO_SYURYO_JIKAN
                        "
                      >
                        〜
                      </span>
                      {{ nosya.EIGYO_SYURYO_JIKAN }}
                    </span>
                  </td>
                </tr>
                <tr v-if="!isLease && isNosyaAA">
                  <th><span>オークション開催日</span></th>
                  <td>
                    <span>{{ form.NOSYA_AA_KAISAI_BI }}</span>
                  </td>
                </tr>
                <tr v-if="!isLease && isNosyaAA">
                  <th><span>POS番号（会員番号）</span></th>
                  <td>
                    <span>{{ form.NOSYA_AA_POS_BANGO }}</span>
                  </td>
                </tr>
                <tr v-if="!isLease && isNosyaAA">
                  <th><span>出品者</span></th>
                  <td>
                    <span>{{ form.NOSYA_AA_SYUPPIN_MEI }}</span>
                  </td>
                </tr>
                <tr v-if="!isLease && isNosyaAA">
                  <th><span>会場担当者</span></th>
                  <td>
                    <span>{{ form.NOSYA_AA_KAIJYO_TANTO_MEI }}</span>
                  </td>
                </tr>
                <template>
                  <tr>
                    <th><span>納車希望日</span></th>
                    <td>
                      <div>{{ nosyaKibouBiType }}</div>
                      <div v-if="isNosyaKibouDateTimeVisible">{{ form.NOSYA_KIBOU_BI }}</div>
                    </td>
                  </tr>
                  <tr>
                    <th><span>納車希望時間</span></th>
                    <td>
                      <div>{{ nosyaKibouJikanType }}</div>
                      <div v-if="isNosyaKibouJikanReasonVisible">{{ form.NOSYA_KIBOU_JIKAN_REASON }}</div>
                    </td>
                  </tr>
                </template>
                <tr>
                  <th><span>納車前の事前連絡</span></th>
                  <td>
                    <span>
                      {{
                        getText(
                          yesNoList,
                          Number(form.NOSYA_JIZEN_RENRAKU_FLG)
                        )
                      }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <th><span>備考</span></th>
                  <td>
                    <span>{{ form.NOSYA_BIKOU }}</span>
                  </td>
                </tr>
              </table>
            </section>
          </div>

          <h4 class="page-sub-title pl-2 pl-md-4 mt-4 mt-md-5">車両</h4>
          <div class="section-wrapper">
            <section class="order-syaryo">
              <table class="table">
                <tr>
                  <th>車検の有無</th>
                  <td>
                    <div class="ml-md-4">
                      <md-checkbox
                        ref="SYAKEN_FLG"
                        class="form-check-input md-primary"
                        :true-value="1"
                        :false-value="0"
                        v-model="syaryo.SYAKEN_FLG"
                      >
                        あり
                      </md-checkbox>
                    </div>
                  </td>
                </tr>
                <SyaryoTypeDetail ref="syaryo_type_detail" :syaryo="syaryo" />
                <tr>
                  <th>
                    メーカー名・車名
                    <span class="must">必須</span>
                  </th>
                  <td>
                    <div class="row ml-3 ml-md-0">
                      <div class="row col-lg-5 px-0 pr-md-2 mb-2 mb-md-0">
                        <label class="col-md-4 mt-md-2 px-0 pl-md-3 m-0">
                          <strong>メーカー名</strong>
                        </label>
                        <validation-provider
                          v-slot="{ errors, touched }"
                          name="SYARYO_MAKER_MEI"
                          rules="required|max:20|char"
                          class="col-md-7 mb-md-2 mb-lg-0 px-0"
                        >
                          <vue-simple-suggest
                            ref="SYARYO_MAKER_MEI"
                            :class="{
                              'border-red':
                                (isVlidated || touched) && errors.length,
                            }"
                            v-model="syaryo.SYARYO_MAKER_MEI"
                            :max-suggestions="15"
                            :list="makerList"
                            :styles="
                              (isVlidated || touched) && errors.length
                                ? autoCompleteStyleError
                                : autoCompleteStyle
                            "
                            @suggestion-click="setSyameiList"
                            @blur="
                              setSyameiList()
                              syaryo.SYARYO_MAKER_MEI = replaceChar(
                                syaryo.SYARYO_MAKER_MEI
                              )
                            "
                            maxlength="20"
                            placeholder="トヨタ"
                            :filter-by-query="true"
                          />
                          <div
                            v-show="(isVlidated || touched) && errors.length"
                            class="invalid-feedback"
                            style="display: block"
                          >
                            <span class="border-red">{{ errors[0] }}</span>
                          </div>
                        </validation-provider>
                      </div>
                      <div class="row col-lg-7 px-0 pl-md-2">
                        <label class="col-md-4 col-lg-1 mt-2 px-0 m-0">
                          <strong>車名</strong>
                        </label>
                        <validation-provider
                          v-slot="{ errors, touched }"
                          rules="required|max:20|char"
                          class="col-md-7 px-0"
                          name="SYARYO_MEI"
                        >
                          <vue-simple-suggest
                            ref="SYARYO_MEI"
                            :class="{
                              'border-red':
                                (isVlidated || touched) && errors.length,
                            }"
                            v-model="syaryo.SYARYO_MEI"
                            :max-suggestions="15"
                            :list="syameiList"
                            :styles="
                              (isVlidated || touched) && errors.length
                                ? autoCompleteStyleError
                                : autoCompleteStyle
                            "
                            maxlength="20"
                            placeholder="プリウス"
                            :filter-by-query="true"
                            @blur="
                              syaryo.SYARYO_MEI = replaceChar(syaryo.SYARYO_MEI)
                            "
                          />
                          <div
                            v-show="(isVlidated || touched) && errors.length"
                            class="invalid-feedback"
                            style="display: block"
                          >
                            <span class="border-red">{{ errors[0] }}</span>
                          </div>
                        </validation-provider>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>
                    車台番号・登録番号
                    <span class="must">必須</span>
                    <p class="f-size-12">※どちらか一方を必ずご入力ください。</p>
                  </th>
                  <td>
                    <div class="row ml-1 mr-1 mb-2">
                      <label class="mt-2 mr-md-3 mb-0">
                        <strong>車台番号</strong>
                      </label>
                      <validation-provider
                        name="SYADAI_BANGO"
                        v-slot="{ errors }"
                        :rules="`${
                          !syaryo.TOUROKU_BANGO ? 'required|' : ''
                        }byte:20|max:20|char`"
                        class="col-md-4"
                      >
                        <b-form-input
                          ref="SYADAI_BANGO"
                          v-model="syaryo.SYADAI_BANGO"
                          :state="errors.length ? false : null"
                          placeholder="GGH20-1111111"
                          trim
                          maxlength="20"
                          @blur="
                            syaryo.SYADAI_BANGO = replaceChar(
                              syaryo.SYADAI_BANGO
                            )
                          "
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                    <div class="row ml-1 mb-2">
                      <label ref="TOUROKU_BANGO" class="mt-2 mr-md-3 mb-0">
                        <strong>登録番号</strong>
                      </label>
                      <div v-if="isMobile" class="col-12" />
                      <validation-provider
                        name="torokubango1"
                        v-slot="{ errors }"
                        :rules="isRequiredTorokuBnago ? 'required|' : ''"
                        class="col-5 col-md-2 pr-0"
                      >
                          <simple-combo-box
                            ref="torokubango1"
                            v-model="syaryo.torokubango1"
                            :options="numberArea"
                            placeholder="未選択"
                            :has-error="errors.length > 0"
                            @change="onChangeTorokubango"
                          />
                          <b-form-invalid-feedback>
                            <span class="border-red">{{ errors[0] }}</span>
                          </b-form-invalid-feedback>
                      </validation-provider>
                      <span class="mt-1 mx-1">-</span>
                      <validation-provider
                        name="torokubango2"
                        v-slot="{ errors }"
                        :rules="`${
                          isRequiredTorokuBnago ? 'required|' : ''
                        }max:4|char`"
                        class="col-5 col-md-2 px-0"
                      >
                        <b-form-input
                          ref="torokubango2"
                          v-model="syaryo.torokubango2"
                          maxlength="4"
                          :state="errors.length ? false : null"
                          placeholder="500"
                          trim
                          @change="onChangeTorokubango"
                          @blur="
                            syaryo.torokubango2 = replaceChar(
                              syaryo.torokubango2
                            )
                          "
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                      <span class="mt-1 mx-1">-</span>
                      <validation-provider
                        name="torokubango3"
                        v-slot="{ errors }"
                        :rules="`${
                          isRequiredTorokuBnago ? 'required|' : ''
                        }max:2|hiraganaPlate`"
                        class="col-5 col-md-1 pr-0 px-md-0 mt-2 mt-md-0"
                      >
                        <b-form-input
                          ref="torokubango3"
                          v-model="syaryo.torokubango3"
                          maxlength="2"
                          :state="errors.length ? false : null"
                          placeholder="と"
                          trim
                          @change="onChangeTorokubango"
                          @blur="
                            syaryo.torokubango3 = replaceChar(
                              syaryo.torokubango3
                            )
                          "
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                      <span class="mt-1 mx-1">-</span>
                      <validation-provider
                        name="torokubango4"
                        v-slot="{ errors }"
                        :rules="`${
                          isRequiredTorokuBnago ? 'required|' : ''
                        }max:6|char`"
                        class="col-5 col-md-2 px-0 mt-2 mt-md-0"
                      >
                        <b-form-input
                          ref="torokubango4"
                          v-model="syaryo.torokubango4"
                          maxlength="6"
                          :state="errors.length ? false : null"
                          placeholder="1234"
                          trim
                          @change="onChangeTorokubango"
                          @blur="
                            syaryo.torokubango4 = replaceChar(
                              syaryo.torokubango4
                            )
                          "
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>
                    長さ・幅・高さ(cm)
                    <span v-if="isRequiredNagasaHabaTakasa" class="must">
                      必須
                    </span>
                  </th>
                  <td>
                    <div class="row mr-1 mb-2">
                      <div class="col-4 col-md-3 pr-0">
                        <div class="row">
                          <label
                            class="col-4 col-md-5 col-lg-4 mt-2 ml-md-1 pr-0"
                          >
                            <strong>長さ</strong>
                          </label>
                          <validation-provider
                            name="SYARYO_NAGASA"
                            v-slot="{ errors }"
                            :rules="{
                              required: isRequiredNagasaHabaTakasa,
                              numeric: true,
                              max: 4,
                            }"
                            class="col-8 col-md-6 px-md-0"
                          >
                            <b-form-input
                              ref="SYARYO_NAGASA"
                              type="tel"
                              maxlength="4"
                              v-model="syaryo.SYARYO_NAGASA"
                              :state="errors.length ? false : null"
                              placeholder="450"
                              trim
                            />
                            <b-form-invalid-feedback>
                              <span class="border-red">{{ errors[0] }}</span>
                            </b-form-invalid-feedback>
                          </validation-provider>
                        </div>
                      </div>
                      <div class="col-4 col-md-3 pr-0">
                        <div class="row">
                          <label
                            class="col-3 col-md-4 col-lg-3 mt-2 ml-md-1 pr-0"
                          >
                            <strong>幅</strong>
                          </label>
                          <validation-provider
                            name="SYARYO_HABA"
                            v-slot="{ errors }"
                            :rules="{
                              required: isRequiredNagasaHabaTakasa,
                              numeric: true,
                              max: 3,
                            }"
                            class="col-8 col-md-6 px-md-0"
                          >
                            <b-form-input
                              ref="SYARYO_HABA"
                              type="tel"
                              maxlength="3"
                              v-model="syaryo.SYARYO_HABA"
                              :state="errors.length ? false : null"
                              placeholder="170"
                              trim
                            />
                            <b-form-invalid-feedback>
                              <span class="border-red">{{ errors[0] }}</span>
                            </b-form-invalid-feedback>
                          </validation-provider>
                        </div>
                      </div>
                      <div class="col-4 col-md-3 px-0">
                        <div class="row">
                          <label
                            class="col-4 col-md-5 col-lg-4 mt-2 ml-md-1 pr-0"
                          >
                            <strong>高さ</strong>
                          </label>
                          <validation-provider
                            name="SYARYO_TAKASA"
                            v-slot="{ errors }"
                            :rules="{
                              required: isRequiredNagasaHabaTakasa,
                              numeric: true,
                              max: 3,
                            }"
                            class="col-8 col-md-6 px-md-0"
                          >
                            <b-form-input
                              ref="SYARYO_TAKASA"
                              type="tel"
                              maxlength="3"
                              v-model="syaryo.SYARYO_TAKASA"
                              :state="errors.length ? false : null"
                              placeholder="140"
                              trim
                            />
                            <b-form-invalid-feedback>
                              <span class="border-red">{{ errors[0] }}</span>
                            </b-form-invalid-feedback>
                          </validation-provider>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr v-if="isSyaryoTypeKbnTruck">
                  <th>積載量・重量(kg)</th>
                  <td>
                    <div class="row mr-1 mb-2">
                      <div class="col-4 col-md-3 pr-0">
                        <div class="row">
                          <label
                            class="col-4 col-md-5 col-lg-4 mt-2 ml-md-1 pr-0"
                          >
                            <strong>積載量</strong>
                          </label>
                          <validation-provider
                            name="SYARYO_SEKISAIRYO"
                            v-slot="{ errors }"
                            :rules="{ numeric: true, max: 4 }"
                            class="col-8 col-md-6 px-md-0"
                          >
                            <b-form-input
                              ref="SYARYO_SEKISAIRYO"
                              type="tel"
                              maxlength="4"
                              v-model="syaryo.SYARYO_SEKISAIRYO"
                              :state="errors.length ? false : null"
                              placeholder="2200"
                              trim
                            />
                            <b-form-invalid-feedback>
                              <span class="border-red">{{ errors[0] }}</span>
                            </b-form-invalid-feedback>
                          </validation-provider>
                        </div>
                      </div>
                      <div class="col-4 col-md-3 pr-0">
                        <div class="row">
                          <label
                            class="col-3 col-md-4 col-lg-3 mt-2 ml-md-1 pr-0"
                          >
                            <strong>重量</strong>
                          </label>
                          <validation-provider
                            name="SYARYO_JYURYO"
                            v-slot="{ errors }"
                            :rules="{
                              numeric: true,
                              max: 4,
                            }"
                            class="col-8 col-md-6 px-md-0"
                          >
                            <b-form-input
                              ref="SYARYO_JYURYO"
                              type="tel"
                              maxlength="4"
                              v-model="syaryo.SYARYO_JYURYO"
                              :state="errors.length ? false : null"
                              placeholder="3800"
                              trim
                            />
                            <b-form-invalid-feedback>
                              <span class="border-red">{{ errors[0] }}</span>
                            </b-form-invalid-feedback>
                          </validation-provider>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>貴社管理番号</th>
                  <td>
                    <validation-provider
                      name="KISYA_KANRI_BANGO"
                      v-slot="{ errors }"
                      rules="max:20|char"
                    >
                      <b-form-input
                        ref="KISYA_KANRI_BANGO"
                        class="col-md-6"
                        maxlength="20"
                        v-model="syaryo.KISYA_KANRI_BANGO"
                        :state="errors.length ? false : null"
                        placeholder="12345"
                        trim
                        @blur="
                          syaryo.KISYA_KANRI_BANGO = replaceChar(
                            syaryo.KISYA_KANRI_BANGO
                          )
                        "
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </td>
                </tr>
                <tr v-if="!isLease && isHikitoriAA">
                  <th>
                    出品番号
                    <span class="must">必須</span>
                  </th>
                  <td>
                    <validation-provider
                      name="SYUPPIN_BANGO"
                      v-slot="{ errors }"
                      rules="required|max:20|char"
                    >
                      <b-form-input
                        ref="SYUPPIN_BANGO"
                        class="col-md-6"
                        maxlength="20"
                        v-model="syaryo.SYUPPIN_BANGO"
                        :state="errors.length ? false : null"
                        placeholder="123456"
                        trim
                        @blur="
                          syaryo.SYUPPIN_BANGO = replaceChar(
                            syaryo.SYUPPIN_BANGO
                          )
                        "
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                    <p v-if="!isLease" class="mt-2 red f-size-14">
                      ※出品番号によっては現車場所が異なる場合があります。今一度現車場所のご確認をお願いいたします。
                    </p>
                  </td>
                </tr>
                <tr v-if="!isLease && isHikitoriAA">
                  <th ref="HANSYUTUKEN">搬出券</th>
                  <td>
                    <validation-provider
                      name="HANSYUTUKEN_URL"
                      v-slot="{ errors }"
                    >
                      <b-form-input
                        v-show="false"
                        v-model="syaryo.HANSYUTUKEN_URL"
                      />
                      <vue-dropzone
                        ref="HANSYUTUKEN_URL"
                        id="dropzone"
                        :options="dropzoneOptions"
                        :class="[
                          {
                            'border-red': errors.length,
                            'is-invalid': errors.length,
                          },
                        ]"
                        @vdropzone-processing="vfileSend"
                        @vdropzone-success="vfileSent"
                        @vdropzone-removed-file="removeFile"
                        @vdropzone-error="onFileError"
                      />
                      <div v-if="errors.length" class="invalid-feedback">
                        <span class="border-red">{{ errors[0] }}</span>
                      </div>
                    </validation-provider>
                    <p class="mt-2 red f-size-14">
                      ※アイオーク・オークネット・シグマネット・JUトレード・TAA・JAA・ハナマル落札の場合、搬出券のアップロードが必須になります。
                    </p>
                  </td>
                </tr>
                <tr>
                  <th>その他ファイル</th>
                  <td>
                    <vue-dropzone
                      ref="OTHER_FILE_LIST"
                      id="dropzone-other"
                      :options="dropzoneOtherOptions"
                      @vdropzone-processing="vfileOtherSend"
                      @vdropzone-success="vfileOtherSent"
                      @vdropzone-removed-file="removeOtherFile"
                      @vdropzone-file-added="addedOtherFile"
                      @vdropzone-error="onOtherFileError"
                    />
                  </td>
                </tr>
              </table>
            </section>
          </div>

          <h4 class="page-sub-title pl-2 pl-md-4 mt-5" v-if="isNosyaYard">
            搬入時に必要な情報
          </h4>
          <div class="section-wrapper" v-if="isNosyaYard">
            <section class="order-hannyu">
              <table class="table">
                <tr>
                  <th>
                    搬入名義
                    <span class="must">必須</span>
                  </th>
                  <td>
                    <validation-provider
                      name="HANNYU_MEI"
                      v-slot="{ errors }"
                      rules="required|max:25|char"
                    >
                      <b-form-input
                        ref="HANNYU_MEI"
                        class="col-md-8"
                        maxlength="25"
                        v-model="syaryo.HANNYU_MEI"
                        :state="errors.length ? false : null"
                        placeholder="株式会社○○"
                        trim
                        @blur="
                          syaryo.HANNYU_MEI = replaceChar(syaryo.HANNYU_MEI)
                        "
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </td>
                </tr>
                <tr>
                  <th>扱い名</th>
                  <td>
                    <validation-provider
                      name="ATSUKAI_MEI"
                      v-slot="{ errors }"
                      rules="max:25|char"
                    >
                      <b-form-input
                        ref="ATSUKAI_MEI"
                        class="col-md-8"
                        maxlength="25"
                        v-model="syaryo.ATSUKAI_MEI"
                        :state="errors.length ? false : null"
                        placeholder="株式会社△△"
                        trim
                        @blur="
                          syaryo.ATSUKAI_MEI = replaceChar(syaryo.ATSUKAI_MEI)
                        "
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </td>
                </tr>
                <tr>
                  <th>向け地</th>
                  <td>
                    <validation-provider
                      name="MUKETI_MEI"
                      v-slot="{ errors }"
                      rules="max:25|char"
                    >
                      <b-form-input
                        ref="MUKETI_MEI"
                        class="col-md-8"
                        maxlength="25"
                        v-model="syaryo.MUKETI_MEI"
                        :state="errors.length ? false : null"
                        placeholder="ニュージーランド"
                        trim
                        @blur="
                          syaryo.MUKETI_MEI = replaceChar(syaryo.MUKETI_MEI)
                        "
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </td>
                </tr>
              </table>
            </section>
          </div>

          <h4 class="page-sub-title pl-2 pl-md-4 mt-5">状態確認</h4>
          <div class="section-wrapper">
            <section class="order-jyotai">
              <table class="table">
                <tr v-if="isLease">
                  <th>
                    自走してもよろしいですか？
                    <span class="must">必須</span>
                  </th>
                  <td>
                    <div class="row">
                      <div class="col-md-6 col-lg-3">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                          name="JISOU_KBN"
                        >
                          <b-form-select
                            ref="JISOU_KBN"
                            v-model="syaryo.JISOU_KBN"
                            :state="errors.length ? false : null"
                            :options="jisouKbnList"
                            trim
                          />
                          <b-form-invalid-feedback>
                            <span class="border-red">{{ errors[0] }}</span>
                          </b-form-invalid-feedback>
                        </validation-provider>
                      </div>
                    </div>
                    <p class="mt-2 red f-size-14">
                      ※積載指定の場合は料金が高額になる場合がございます。
                    </p>
                  </td>
                </tr>
              </table>
              <SyaryoConditions
                ref="syaryo_conditions"
                :conditions="syaryo.CAR_CONDITIONS"
              />
            </section>
          </div>

          <h4 class="page-sub-title pl-2 pl-md-4 mt-5">その他</h4>
          <div class="section-wrapper">
            <section class="order-biko">
              <h5 class="_page-sub-title pl-2 pl-md-4">車両備考</h5>
              <table class="table">
                <tr>
                  <th>備考</th>
                  <td>
                    <validation-provider
                      name="BIKO"
                      v-slot="{ errors }"
                      rules="max:30|char"
                    >
                      <b-form-textarea
                        ref="BIKO"
                        maxlength="30"
                        v-model="syaryo.BIKO"
                        :state="errors.length ? false : null"
                        trim
                        @blur="syaryo.BIKO = replaceChar(syaryo.BIKO)"
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </td>
                </tr>
              </table>
              <div class="text-right f-size-14">
                {{ syaryo.BIKO ? syaryo.BIKO.length : 0 }}/30
              </div>
            </section>
          </div>

          <h4 id="individual-option" class="page-sub-title pl-2 pl-md-4 mt-5">
            車両別オプション
          </h4>
          <div class="section-wrapper">
            <section class="order-option">
              <h5
                v-if="isLease"
                class="_page-sub-title pl-2 pl-md-4 mt-3 mt-md-4"
              >
                清掃サービス
              </h5>
              <table v-if="isLease" class="table">
                <tr>
                  <th>清掃サービス</th>
                  <td>
                    <div class="row">
                      <div class="col-md-4 col-lg-3">
                        <validation-provider
                          v-slot="{ errors }"
                          name="SEISOU_FLG"
                        >
                          <b-form-select
                            ref="SEISOU_FLG"
                            v-model="syaryo.SEISOU_FLG"
                            :state="errors.length ? false : null"
                            :options="yesNoHopeList"
                            trim
                          />
                          <b-form-invalid-feedback>
                            <span class="border-red">{{ errors[0] }}</span>
                          </b-form-invalid-feedback>
                        </validation-provider>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr v-if="Number(syaryo.SEISOU_FLG)">
                  <th>
                    清掃内容
                    <span class="must">必須</span>
                  </th>
                  <td>
                    <div class="p-1">
                      <div
                        v-if="Number(syaryo.SYARYO_TYPE_KBN) === 1"
                        class="form-check form-check-inline col-md-12 py-1"
                      >
                        <input
                          ref="SEISOU_KBN"
                          class="form-check-input"
                          type="radio"
                          id="seisou-flg-3"
                          value="10"
                          v-model="syaryo.SEISOU_KBN"
                        />
                        <label class="form-check-label" for="seisou-flg-3">
                          スタンド立寄り洗車（簡易車外と室内）
                        </label>
                      </div>
                      <div
                        v-if="Number(syaryo.SYARYO_TYPE_KBN) === 1"
                        class="form-check form-check-inline col-md-12 py-1"
                      >
                        <input
                          ref="SEISOU_KBN"
                          class="form-check-input"
                          type="radio"
                          id="seisou-flg-4"
                          value="11"
                          v-model="syaryo.SEISOU_KBN"
                        />
                        <label class="form-check-label" for="seisou-flg-4">
                          ヤード内での洗車（車外・室内）
                        </label>
                      </div>
                      <div class="form-check form-check-inline col-md-12 py-1">
                        <input
                          ref="SEISOU_KBN"
                          class="form-check-input"
                          type="radio"
                          id="seisou-flg-5"
                          value="12"
                          v-model="syaryo.SEISOU_KBN"
                        />
                        <label class="form-check-label" for="seisou-flg-5">
                          室内清掃（ダスキン標準） 15,000円～
                        </label>
                      </div>
                      <div class="form-check form-check-inline col-md-12 py-1">
                        <input
                          ref="SEISOU_KBN"
                          class="form-check-input"
                          type="radio"
                          id="seisou-flg-6"
                          value="13"
                          v-model="syaryo.SEISOU_KBN"
                        />
                        <label class="form-check-label" for="seisou-flg-6">
                          室内清掃（ダスキンスペシャル） 28,000円～
                        </label>
                      </div>
                    </div>
                  </td>
                </tr>
              </table>

              <h5
                :class="[
                  'page-sub-title pl-2 pl-md-4 mt-3 mt-md-4',
                  { '_page-sub-title': !isLease },
                ]"
              >
                ナンバープレート別送サービス
              </h5>
              <table class="table">
                <tr>
                  <th>ナンバープレート別送サービスのご希望</th>
                  <td>
                    <div class="row">
                      <div class="col-6 col-md-3">
                        <validation-provider
                          v-slot="{ errors }"
                          name="NUMBER_PLATE_FLG"
                        >
                          <b-form-select
                            ref="NUMBER_PLATE_FLG"
                            v-model="syaryo.NUMBER_PLATE_FLG"
                            :state="errors.length ? false : null"
                            :options="yesNoHopeList"
                            trim
                          />
                          <b-form-invalid-feedback>
                            <span class="border-red">{{ errors[0] }}</span>
                          </b-form-invalid-feedback>
                        </validation-provider>
                      </div>
                      <button
                        v-if="Number(syaryo.NUMBER_PLATE_FLG)"
                        type="button"
                        :class="[
                          'btn btn-success bold col-5',
                          { center: isMobile },
                        ]"
                        @click="isShowNPDialog = true"
                      >
                        履歴から選択
                      </button>
                    </div>
                  </td>
                </tr>
                <tr v-if="Number(syaryo.NUMBER_PLATE_FLG)">
                  <th>
                    名称
                    <span class="must">必須</span>
                  </th>
                  <td>
                    <validation-provider
                      name="NUMBER_PLATE_MEI"
                      v-slot="{ errors }"
                      rules="required|max:40|char"
                    >
                      <b-form-input
                        ref="NUMBER_PLATE_MEI"
                        v-model="syaryo.NUMBER_PLATE_MEI"
                        maxlength="40"
                        :state="errors.length ? false : null"
                        placeholder="株式会社ロジコ"
                        trim
                        @blur="
                          syaryo.NUMBER_PLATE_MEI = replaceChar(
                            syaryo.NUMBER_PLATE_MEI
                          )
                        "
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </td>
                </tr>
                <tr v-if="Number(syaryo.NUMBER_PLATE_FLG)">
                  <th>郵便番号</th>
                  <td>
                    <div class="row">
                      <div class="col-4 col-md-3 col-lg-2">
                        <validation-provider
                          name="NUMBER_PLATE_YUBIN1"
                          v-slot="{ errors }"
                          rules="numeric|digits:3"
                        >
                          <b-form-input
                            ref="NUMBER_PLATE_YUBIN1"
                            type="tel"
                            maxlength="3"
                            v-model="syaryo.NUMBER_PLATE_YUBIN1"
                            :state="errors.length ? false : null"
                            placeholder="160"
                            trim
                          />
                          <b-form-invalid-feedback>
                            <span class="border-red">{{ errors[0] }}</span>
                          </b-form-invalid-feedback>
                        </validation-provider>
                      </div>
                      <span class="py-2">-</span>
                      <div class="col-4 col-md-3 col-lg-2">
                        <validation-provider
                          name="NUMBER_PLATE_YUBIN2"
                          v-slot="{ errors }"
                          rules="numeric|digits:4"
                        >
                          <b-form-input
                            ref="NUMBER_PLATE_YUBIN2"
                            type="tel"
                            maxlength="4"
                            v-model="syaryo.NUMBER_PLATE_YUBIN2"
                            :state="errors.length ? false : null"
                            placeholder="0023"
                            trim
                          />
                          <b-form-invalid-feedback>
                            <span class="border-red">{{ errors[0] }}</span>
                          </b-form-invalid-feedback>
                        </validation-provider>
                      </div>
                      <button
                        type="button"
                        class="btn btn-success bold"
                        @click="searchNPZip"
                        style="height: 40px"
                      >
                        検索
                      </button>
                    </div>
                  </td>
                </tr>
                <tr v-if="Number(syaryo.NUMBER_PLATE_FLG)">
                  <th>
                    都道府県・市区町村
                    <span class="must">必須</span>
                  </th>
                  <td>
                    <div class="row">
                      <div
                        ref="NUMBER_PLATE_TODO_MEI"
                        class="col-4 col-md-4 col-lg-3 pr-0"
                      >
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                          name="NUMBER_PLATE_TODO_CD"
                        >
                          <b-form-select
                            ref="NUMBER_PLATE_TODO_CD"
                            v-model="syaryo.NUMBER_PLATE_TODO_CD"
                            :state="errors.length ? false : null"
                            :options="prefList"
                            trim
                            @change="changeNPPref"
                          />
                          <b-form-invalid-feedback>
                            <span class="border-red">{{ errors[0] }}</span>
                          </b-form-invalid-feedback>
                        </validation-provider>
                      </div>
                      <div
                        ref="NUMBER_PLATE_SHIKU_MEI"
                        class="col-7 col-md-5 col-lg-4"
                      >
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                          name="NUMBER_PLATE_SHIKU_CD"
                        >
                          <b-form-select
                            ref="NUMBER_PLATE_SHIKU_CD"
                            :disabled="!nPCityList.length"
                            v-model="syaryo.NUMBER_PLATE_SHIKU_CD"
                            :state="errors.length ? false : null"
                            :options="nPCityList"
                            trim
                            @change="changeNPCity"
                          />
                          <b-form-invalid-feedback>
                            <span class="border-red">{{ errors[0] }}</span>
                          </b-form-invalid-feedback>
                        </validation-provider>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr v-if="Number(syaryo.NUMBER_PLATE_FLG)">
                  <th>
                    番地建物名
                    <span class="must">必須</span>
                  </th>
                  <td>
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required|max:25|char"
                      name="NUMBER_PLATE_BANCHI"
                    >
                      <b-form-input
                        maxlength="25"
                        v-model="syaryo.NUMBER_PLATE_BANCHI"
                        :state="errors.length ? false : null"
                        placeholder="西新宿7－4－3 升本ビル4F"
                        trim
                        ref="NUMBER_PLATE_BANCHI"
                        @blur="
                          syaryo.NUMBER_PLATE_BANCHI = replaceChar(
                            syaryo.NUMBER_PLATE_BANCHI
                          )
                        "
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </td>
                </tr>
                <tr v-if="Number(syaryo.NUMBER_PLATE_FLG)">
                  <th>
                    TEL
                    <span class="must">必須</span>
                  </th>
                  <td>
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required|tel"
                      name="NUMBER_PLATE_SAKI_TEL"
                    >
                      <b-form-input
                        maxlength="17"
                        class="col-md-5 col-lg-4"
                        v-model="syaryo.NUMBER_PLATE_SAKI_TEL"
                        :state="errors.length ? false : null"
                        placeholder="03-5937-4777"
                        trim
                        ref="NUMBER_PLATE_SAKI_TEL"
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </td>
                </tr>
              </table>

              <h5
                v-if="isIrekaePossible"
                class="page-sub-title pl-2 pl-md-4 mt-3 mt-md-4"
              >
                下取／入れ替え車両
              </h5>
              <table v-if="isIrekaePossible" class="table">
                <tr>
                  <th>下取／入れ替え車両のご希望</th>
                  <td>
                    <div class="row">
                      <div class="col-6 col-md-4 col-lg-3">
                        <validation-provider
                          v-slot="{ errors }"
                          name="IREKAE_FLG"
                        >
                          <b-form-select
                            ref="IREKAE_FLG"
                            v-model="syaryo.IREKAE_FLG"
                            :state="errors.length ? false : null"
                            :options="yesNoHopeList"
                            trim
                          />
                          <b-form-invalid-feedback>
                            <span class="border-red">{{ errors[0] }}</span>
                          </b-form-invalid-feedback>
                        </validation-provider>
                      </div>
                      <div
                        v-show="Number(syaryo.IREKAE_FLG)"
                        class="col-md-4 mt-2 mt-md-0"
                      >
                        <button
                          type="button"
                          class="btn btn-success bold"
                          style="height: 40px"
                          @click="changeIrekaeMode"
                        >
                          下取／入れ替え車両を設定
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
            </section>
          </div>

          <div v-if="!isIrekae">
            <h4 id="option" class="page-sub-title pl-2 pl-md-4 mt-5">
              共通オプション&emsp;
              <br v-if="isMobile" />
              <span class="f-size-16 sp-fs-14">
                ※複数台発注する場合、全ての車両に適用されます
              </span>
            </h4>
            <div class="section-wrapper">
              <section class="order-option">
                <h5
                  v-if="isLease"
                  class="_page-sub-title pl-2 pl-md-4 mt-3 mt-md-4"
                >
                  保管
                </h5>
                <table v-if="isLease" class="table">
                  <tr>
                    <th>保管のご希望</th>
                    <td>
                      <div class="row">
                        <div class="col-md-4 col-lg-3">
                          <validation-provider
                            v-slot="{ errors }"
                            name="HOKAN_FLG"
                          >
                            <b-form-select
                              ref="HOKAN_FLG"
                              v-model="option.HOKAN_FLG"
                              :state="errors.length ? false : null"
                              :options="yesNoHopeList"
                              trim
                            />
                            <b-form-invalid-feedback>
                              <span class="border-red">{{ errors[0] }}</span>
                            </b-form-invalid-feedback>
                          </validation-provider>
                        </div>
                      </div>
                    </td>
                  </tr>
                </table>

                <h5
                  :class="[
                    'page-sub-title pl-2 pl-md-4 mt-3 mt-md-4',
                    { '_page-sub-title': !isLease },
                  ]"
                >
                  ご要望
                </h5>
                <table class="table">
                  <tr>
                    <th>その他ご要望</th>
                    <td>
                      <validation-provider
                        v-slot="{ errors }"
                        rules="max:200|char"
                        name="YOUBOU"
                      >
                        <b-form-textarea
                          ref="YOUBOU"
                          v-model="option.YOUBOU"
                          :state="errors.length ? false : null"
                          trim
                          maxlength="200"
                          @blur="option.YOUBOU = replaceChar(option.YOUBOU)"
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </td>
                  </tr>
                </table>
                <div class="text-right sp-fs-12">
                  {{ option.YOUBOU ? option.YOUBOU.length : 0 }}/200
                </div>
              </section>
            </div>
          </div>
        </validation-observer>

        <div v-if="!isIrekae && isEnableInvoice">
          <h4 class="page-sub-title pl-2 pl-md-4 mt-5">請求先</h4>
          <invoice
            :is-invoice-valid-active="isInvoiceValidActive"
            :parent-form="form"
            @setIsInvoiceValid="setIsInvoiceValid"
            @setIsInvoiceValidActive="setIsInvoiceValidActive"
            @setInvoice="setInvoice"
          />
        </div>

        <div
          v-if="!form.isFromHistoryEdit"
          class="order-btn text-center add-vehicle-wrapper my-3"
        >
          <div v-if="isIrekae">
            <md-button
              class="mt-4 mr-5 md-dense md-primary"
              @click="isShowIrekaeCancelDialog = true"
            >
              キャンセル
            </md-button>
            <span class="another-add">
              <md-button
                type="button"
                class="col-md-2"
                :disabled="isSubmitDisabled"
                @click="addIrekaeVehicle"
              >
                登録
              </md-button>
            </span>
          </div>

          <div v-else-if="isListEdit" class="another-add">
            <md-button
              type="button"
              class="col-11 col-md-4"
              :disabled="isSubmitDisabled"
              @click="updateVehicle"
            >
              更新
            </md-button>
          </div>

          <div v-else class="another-add">
            <md-button
              class="col-11 col-md-4"
              @click="isAddSyaryoListConfirm = true"
            >
              <span class="sp-fs-18">別の車両を追加</span>
            </md-button>
          </div>
        </div>

        <div
          class="text-center mt-5 mr-3 mr-md-0"
          v-if="!isListEdit && !isIrekae"
        >
          <md-button
            type="button"
            class="btn-lg btn-secondary base-btn col-md-3 col-lg-2"
            @click="handleBackButtonClick"
          >
            もどる
          </md-button>
          <br v-if="isMobile" />
          <md-button
            class="md-raised btn-lg btn-success base-btn col-md-3 col-lg-2"
            :disabled="isSubmitDisabled"
            @click="beforeNext(false)"
          >
            次へ
          </md-button>
        </div>
      </div>

      <!-- モーダル -->
      <md-dialog
        :md-active.sync="isShowNPDialog"
        class="new w-800"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
      >
        <md-dialog-title>履歴選択</md-dialog-title>
        <div class="px-4 pb-4 p-md-4">
          <div class="ml-md-3 mb-1 mb-md-2 search-wrapper">
            <div>
              <label
                class="d-md-inline pt-2 col-md-4 col-lg-2 text-left px-0 my-0"
              >
                所在地
              </label>
              <div class="d-md-inline text-left">
                <select
                  class="d-inline form-control col-4 col-md-2 ml-md-2"
                  @change="changePrefFavor()"
                  v-model="search.TODO_CD"
                >
                  <option
                    v-for="pref in prefs"
                    :value="pref.TODO_CD"
                    :key="pref.TODO_CD"
                  >
                    {{ pref.TODO_MEI }}
                  </option>
                </select>
                <select
                  class="d-inline form-control col-7 col-md-3 ml-2"
                  @change="searchNumberPlateCity()"
                  v-model="search.SHIKU_CD"
                  :disabled="!cities.FAVORITE.length"
                >
                  <option
                    v-for="city in cities.FAVORITE"
                    :value="city.SHIKU_CD"
                    :key="city.SHIKU_CD"
                  >
                    {{ city.SHIKU_MEI }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <section id="order-favorite-plate">
            <md-table
              v-if="transports.length"
              class="black-svg h-300 checkbox"
              v-model="transports"
              md-sort="MEI"
              md-sort-order="asc"
              md-card
              md-fixed-header
            >
              <md-table-row
                slot="md-table-row"
                slot-scope="{ item }"
                @click="setTableRowClassAndName(item.id, transports)"
              >
                <md-table-cell v-if="!isMobile" md-label="">
                  <input
                    type="radio"
                    :id="item.ID"
                    :value="item.ID"
                    v-model="picked"
                  />
                </md-table-cell>
                <md-table-cell md-label="名称" md-sort-by="MEI">
                  <span v-if="!isMobile">{{ omitText(item.MEI, 45) }}</span>
                  <div v-else class="row">
                    <p class="col-3 p-0 bold">名称</p>
                    <p class="col-9 p-0">{{ _omitText(item.MEI, 18) }}</p>
                  </div>
                </md-table-cell>

                <md-table-cell md-label="住所" md-sort-by="ADDRESS">
                  <span v-if="!isMobile">{{ omitText(item.ADDRESS, 45) }}</span>
                  <div v-else class="row">
                    <p class="col-3 p-0 bold">住所</p>
                    <p class="col-9 p-0">{{ _omitText(item.ADDRESS, 18) }}</p>
                  </div>
                </md-table-cell>
              </md-table-row>
            </md-table>
            <div v-else class="text-center mt-3">該当データがありません。</div>
            <md-dialog-actions>
              <md-button class="md-primary" @click="isShowNPDialog = false">
                閉じる
              </md-button>
              <md-button
                class="md-primary"
                @click="
                  isShowNPDialog = false
                  selectNP(selectedObj)
                "
              >
                決定
              </md-button>
            </md-dialog-actions>
          </section>
        </div>
      </md-dialog>

      <md-dialog
        :md-active.sync="isShowNosyaDetailDialog"
        class="new w-800 h-100per"
        :md-fullscreen="false"
        :md-click-outside-to-close="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
      >
        <md-dialog-title>
          下取/入れ替え車両の納車先情報を入力してください
        </md-dialog-title>
        <hiki-no-detail
          style="max-height: 500px; overflow: scroll"
          class="px-md-4"
          :is-get-data="isGetNosyaDetail"
          :_form="form"
          :is-nosya-only="true"
          :is-nosya-a-a="
            !isLease &&
            tmpIrekaeNosya[irekaeNosyaActiveKbn] &&
            tmpIrekaeNosya[irekaeNosyaActiveKbn].data.AA_CD
              ? 1
              : 0
          "
          @setInvalid="onSetNosyaDetail"
        />
        <md-dialog-actions>
          <md-button
            class="md-primary"
            @click="
              isShowNosyaDetailDialog = false
              isShowIrekaeNosyaDialog = true
            "
          >
            閉じる
          </md-button>
          <md-button class="md-primary" @click="isGetNosyaDetail = true">
            決定
          </md-button>
        </md-dialog-actions>
      </md-dialog>

      <md-dialog-confirm
        class="new"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
        :md-active.sync="isAddSyaryoListConfirm"
        md-title=""
        md-content="<strong>入力中の車両情報を発注車両リストに追加して続けますか？</strong>"
        md-confirm-text="はい"
        md-cancel-text="いいえ"
        :md-click-outside-to-close="false"
        @md-confirm="addVehicle"
      />

      <md-dialog-confirm
        class="new"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
        :md-active.sync="isEditSyaryoListConfirm"
        md-title=""
        md-content="<strong>入力中の車両情報を発注車両リストに追加して続けますか？</strong>"
        md-confirm-text="はい"
        md-cancel-text="いいえ"
        :md-click-outside-to-close="false"
        @md-confirm="addVehicleAndEdit"
        @md-cancel="editSyaryo"
      />

      <md-dialog-confirm
        class="new pink"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
        :md-active.sync="isForceNextConfirm"
        md-title=""
        md-content="<strong>入力項目にエラーがあります。<br>現在入力中の情報を破棄して進みますか？</strong>"
        md-confirm-text="はい"
        md-cancel-text="いいえ"
        :md-click-outside-to-close="false"
        @md-confirm="next(true)"
        @md-cancel="scrollToErr"
      />

      <md-dialog-alert
        class="new"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
        :md-active.sync="isShowAddedDialog"
        md-content="<strong>発注車両リストに追加しました。</strong>"
      />

      <md-dialog-alert
        class="new"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
        :md-active.sync="isShowEditedDialog"
        md-content="<strong>発注車両リストを更新しました。</strong>"
      />

      <md-dialog-alert
        class="new"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
        :md-active.sync="isShowIrekaeDialog"
        md-content="<strong>下取/入れ替え車両を入力してください。</strong>"
      />

      <md-dialog-alert
        class="new"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
        :md-active.sync="isShowIrekaedDialog"
        md-content="<strong>下取/入れ替え車両を登録しました。</strong>"
      />

      <md-dialog-confirm
        class="new"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
        :md-active.sync="isShowIrekaeCancelDialog"
        md-title=""
        md-content="<strong>下取/入れ替え車両をキャンセルしてよいですか？</strong>"
        md-confirm-text="はい"
        md-cancel-text="いいえ"
        :md-click-outside-to-close="false"
        @md-confirm="cancelIrekaeVehicle"
        @md-cancel="isShowIrekaeCancelDialog = false"
      />

      <md-dialog-alert
        class="new"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
        :md-active.sync="isShowIrekaeCanceledDialog"
        md-content="<strong>下取/入れ替え車両をキャンセルしました。</strong>"
      />

      <md-dialog-confirm
        class="new"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
        :md-active.sync="isShowIrekaeCnacelConfirmDialog"
        md-title=""
        md-content="<strong>下取/入れ替え車両のご希望をキャンセルしますか？</strong>"
        md-confirm-text="はい"
        md-cancel-text="いいえ"
        :md-click-outside-to-close="false"
        @md-confirm="cancelIrekaeVehicle"
        @md-cancel="
          isShowIrekaeCnacelConfirmDialog = false
          isShowIrekaeNosyaDialog = true
        "
      />

      <md-dialog-alert
        class="new pink"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="
          scroll('clear')
          $router.push({ name: 'OrderIndex' })
        "
        :md-active.sync="isShowErrorDialog"
        md-content="<strong>エラーが発生いたしました。大変恐れ入りますが、再度ご発注の入力をお願い致します。</strong>"
      />

      <!-- 入れ替え納車先選択メニュー -->
      <md-dialog
        :md-active.sync="isShowIrekaeNosyaDialog"
        class="new w-600"
        :md-fullscreen="false"
        :md-click-outside-to-close="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
      >
        <md-dialog-title>納車先を選択</md-dialog-title>
        <p class="text-center mb-2 red f-size-14">
          ※下取／入れ替え車両の納車先を入力してください。
        </p>
        <div class="px-4 text-center">
          <md-button
            type="button"
            class="btn-lg btn-success base-btn col-md-9 mb-2 mb-md-3 m-0"
            @click="showMasterDialog"
          >
            登録済みの場所
          </md-button>
          <md-button
            type="button"
            class="btn-lg btn-success base-btn col-md-9 mb-2 mb-md-3 m-0"
            @click="showDirectDialog"
          >
            直接場所を指定
          </md-button>
          <md-button
            type="button"
            class="btn-lg btn-success base-btn col-md-9 mb-2 mb-md-3 m-0"
            @click="showFavoriteDialog"
          >
            お気に入りの場所
          </md-button>
        </div>
        <md-dialog-actions>
          <md-button
            class="md-primary"
            @click="
              isShowIrekaeNosyaDialog = false
              if (!irekaeNosya) isShowIrekaeCnacelConfirmDialog = true
            "
          >
            閉じる
          </md-button>
        </md-dialog-actions>
      </md-dialog>

      <!-- 登録済みの場所 -->
      <md-dialog
        :md-active.sync="isShowMasterDialog"
        class="new w-800 h-100per"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
      >
        <md-dialog-title>登録済みの場所から選択</md-dialog-title>
        <div class="px-md-4">
          <master
            class="pt-2 pb-3 px-2 px-md-0"
            :is-dialog="true"
            :is-search="tmpIrekaeNosya.MASTER.isSearch"
            :is-valid="tmpIrekaeNosya.MASTER.isValid"
            :_search-cond="tmpIrekaeNosya.MASTER.cond"
            @setData="onSetIrekaeNosya"
            @setInvalid="onSetIrekaeNosyaInvalid"
            @searched="onSetIrekaeNosyaIsSearch"
          />
        </div>
        <md-dialog-actions>
          <md-button
            class="md-primary"
            @click="
              isShowIrekaeNosyaDialog = true
              isShowMasterDialog = false
            "
          >
            閉じる
          </md-button>
          <md-button
            class="md-primary"
            @click="tmpIrekaeNosya.MASTER.isValid = true"
          >
            決定
          </md-button>
        </md-dialog-actions>
      </md-dialog>

      <md-dialog
        :md-active.sync="isShowDirectDialog"
        class="new w-800 h-100per"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
      >
        <md-dialog-title>直接場所を指定</md-dialog-title>
        <div class="px-md-5">
          <direct-edit
            style="max-height: 500px; overflow: scroll"
            :is-dialog="true"
            :is-search="tmpIrekaeNosya.DIRECT.isSearch"
            :is-valid="tmpIrekaeNosya.DIRECT.isValid"
            :_search-cond="tmpIrekaeNosya.DIRECT.cond"
            @setData="onSetIrekaeNosya"
            @setInvalid="onSetIrekaeNosyaInvalid"
            @searched="onSetIrekaeNosyaIsSearch"
          />
        </div>
        <md-dialog-actions>
          <md-button
            class="md-primary"
            @click="
              isShowIrekaeNosyaDialog = true
              isShowDirectDialog = false
            "
          >
            閉じる
          </md-button>
          <md-button
            class="md-primary"
            @click="tmpIrekaeNosya.DIRECT.isValid = true"
          >
            決定
          </md-button>
        </md-dialog-actions>
      </md-dialog>

      <md-dialog
        :md-active.sync="isShowFavoriteDialog"
        class="new w-800 h-100per"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
      >
        <md-dialog-title>お気に入りの場所から選択</md-dialog-title>
        <div class="px-md-4">
          <favorite
            class="pt-2 pb-3 px-2 px-md-0"
            :is-dialog="true"
            :is-search="tmpIrekaeNosya.FAVORITE.isSearch"
            :is-valid="tmpIrekaeNosya.FAVORITE.isValid"
            :_search-cond="tmpIrekaeNosya.FAVORITE.cond"
            @setData="onSetIrekaeNosya"
            @setInvalid="onSetIrekaeNosyaInvalid"
            @searched="onSetIrekaeNosyaIsSearch"
          />
        </div>
        <md-dialog-actions>
          <md-button
            class="md-primary"
            @click="
              isShowIrekaeNosyaDialog = true
              isShowFavoriteDialog = false
            "
          >
            閉じる
          </md-button>
          <md-button
            class="md-primary"
            @click="tmpIrekaeNosya.FAVORITE.isValid = true"
          >
            決定
          </md-button>
        </md-dialog-actions>
      </md-dialog>

      <!-- 一時保存機能 -->
      <temp-save @save="handleTempSaveButtonInModalClick" />
    </div>
  </div>
</template>

<script>
import SimpleComboBox from '@/components/form/SimpleComboBox'
import BFormInputCustom from '@/components/form/input'
import Mixin from '@/components/mixin/Mixin'
import YusouKibouMixin from '@/components/mixin/YusouKibouMixin'
import DirectEdit from '@/components/order/DirectEdit'
import Favorite from '@/components/order/Favorite'
import HikiNoDetail from '@/components/order/HikiNoDetail'
import Master from '@/components/order/Master'
import Navi from '@/components/order/Navi'
import SyaryoConditions from '@/components/order/SyaryoConditions'
import SyaryoTypeDetail from '@/components/order/SyaryoTypeDetail'
import TempSave from '@/components/order/TempSave'
import Invoice from '@/components/order/invoice/Invoice'
import Constant from '@/const'
import { getYusouKibouBiTypeByValue } from '@/constants/yusouKibouBiType'
import { getYusouKibouJikanTypeByValue } from '@/constants/yusouKibouJikanType'
import Store from '@/store/index.js'
import cloneDeep from 'lodash/cloneDeep'
import merge from 'lodash/merge'
import { scroller } from 'vue-scrollto/src/scrollTo'
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'
import vue2Dropzone from 'vue2-dropzone'
import { saveTempData } from '../utils/orderTempSave'

const firstScrollTo = scroller()

const HIKINO_SAKI = {
  AA_KAISAI_BI: null,
  YUBIN1: null,
  YUBIN2: null,
  TODO_CD: null,
  TODO_MEI: null,
  SHIKU_CD: null,
  SHIKU_MEI: null,
  BANCHI: null,
  MEI: null,
  TEL: null,
  FAX: null,
  TANTO_MEI: null,
  TANTO_TEL: null,
  TANTO_FAX: null,
  YUSO_KBN: null,
  HCB_ZOKUSEI_CD: null,
  LANDMARK_KBN: null,
  TEIKYU_BI: null,
  EIGYO_KAISI_JIKAN: null,
  EIGYO_SYURYO_JIKAN: null,
  TOROKUBAYO_KO_ID: null,
  HANNYUSYUTU_JIKAN: null,
  AA_ID: null,
  AA_CD: null,
  FAVORITE_ID: null,
}

const IREKAE_FORM = {
  ACTIVE_HIKITORI_TAB: null,
  ACTIVE_NOSYA_TAB: null,
  HIKITORI_MASTER: cloneDeep(HIKINO_SAKI),
  HIKITORI_DIRECT: cloneDeep(HIKINO_SAKI),
  HIKITORI_AUCTION: cloneDeep(HIKINO_SAKI),
  HIKITORI_FAVORITE: cloneDeep(HIKINO_SAKI),
  HIKITORI_AA_FLG: 0,
  NOSYA_MASTER: cloneDeep(HIKINO_SAKI),
  NOSYA_DIRECT: cloneDeep(HIKINO_SAKI),
  NOSYA_AUCTION: cloneDeep(HIKINO_SAKI),
  NOSYA_FAVORITE: cloneDeep(HIKINO_SAKI),
  NOSYA_AA_FLG: 0,
  HIKITORI_AA_WANPULA_FLG: null,
  HIKITORI_AA_WANPULA_RAKUSATU_BI: null,
  HIKITORI_AA_RYUSATU_SYARYO: null,
  HIKITORI_AA_POS_BANGO: null,
  HIKITORI_AA_NYUKIN_JYOKYO_KBN: '',
  HIKITORI_AA_NYUKIN_YOTEI_BI: null,
  HIKITORI_AA_NYUKIN_YOTEI_JIKAN: '',
  HIKITORI_AA_HANSHUTU_KANOU_BI: null,
  HIKITORI_AA_KAISAI_BI: null,
  HIKITORI_AA_POS_KBN: null,
  HIKITORI_AA_POS_DAIKO_GYOSHA_MEI: null,
  HIKITORI_AA_POS_MEIGI_INFO: null,
  HIKITORI_AA_POS_RAKUSATU_SYUPPIN: null,
  HIKITORI_KIBOU_BI: null,
  HIKITORI_KIBOU_BI_TYPE: null,
  HIKITORI_KIBOU_JIKAN_TYPE: null,
  HIKITORI_KIBOU_JIKAN_REASON: null,
  HIKITORI_JIZEN_RENRAKU_FLG: 0,
  HIKITORI_BIKOU: null,
  NOSYA_AA_POS_BANGO: null,
  NOSYA_AA_SYUPPIN_MEI: null,
  NOSYA_AA_KAIJYO_TANTO_MEI: null,
  NOSYA_AA_POS_KBN: null,
  NOSYA_AA_POS_DAIKO_GYOSHA_MEI: null,
  NOSYA_AA_POS_MEIGI_INFO: null,
  NOSYA_AA_POS_RAKUSATU_SYUPPIN: null,
  NOSYA_KIBOU_BI: null,
  NOSYA_KIBOU_BI_TYPE: null,
  NOSYA_KIBOU_JIKAN_TYPE: null,
  NOSYA_KIBOU_JIKAN_REASON: null,
  NOSYA_JIZEN_RENRAKU_FLG: 0,
}

export default {
  name: 'VehicleMeihen',
  mixins: [Mixin, YusouKibouMixin],
  components: {
    Navi,
    SimpleComboBox,
    vueDropzone: vue2Dropzone,
    VueSimpleSuggest,
    Invoice,
    HikiNoDetail,
    Master,
    DirectEdit,
    Favorite,
    BFormInputCustom,
    SyaryoConditions,
    SyaryoTypeDetail,
    TempSave,
  },
  data: () => ({
    /** 納車先詳細取得フラグ */
    isGetNosyaDetail: false,

    /** 納車先詳細入力Dialog表示フラグ */
    isShowNosyaDetailDialog: false,

    /** ナンバープレート市区町村 */
    nPCityList: [],

    /** オブザーバー */
    observer: null,

    /** 請求先バリデーション発火フラグ **/
    isInvoiceValidActive: false,
    /** 請求先バリデーション結果 **/
    isInvoiceValid: false,
    isErrSyaryoList: false,
    isForceNextConfirm: false,
    isEditSyaryoListConfirm: false,
    isAddSyaryoListConfirm: false,

    /** 入れ替え車両編集確認済みフラグ */
    isCheckedIrekae: false,

    /** 入れ替え車入力Dialog表示フラグ */
    isShowIrekaeDialog: false,

    /** 入れ替え車入力完了Dialog表示フラグ */
    isShowIrekaedDialog: false,

    /** 入れ替え車入力キャンセル確認Dialog表示フラグ */
    isShowIrekaeCancelDialog: false,

    /** 入れ替え車入力キャンセル完了Dialog表示フラグ */
    isShowIrekaeCanceledDialog: false,

    /** 入れ替え車入力キャンセル確認Dialog表示フラグ */
    isShowIrekaeCnacelConfirmDialog: false,

    /** 発注処理エラー表示フラグ */
    isShowErrorDialog: false,

    /** 入れ替え車両入力中フラグ */
    isIrekae: false,

    /** 入れ替え車納車先入力にエラーがあるか */
    isIrekaeNosyaInvalid: false,

    /** 入れ替え納車先選択Dialog表示フラグ */
    isShowIrekaeNosyaDialog: false,

    /** 登録済みの場所Digalog表示フラグ */
    isShowMasterDialog: false,

    /** 直接入力Digalog表示フラグ */
    isShowDirectDialog: false,

    /** お気に入りの場所Digalog表示フラグ */
    isShowFavoriteDialog: false,

    /** formデータの一時退避 */
    tmpForm: null,

    /** syaryoデータの一時退避 */
    tmpSyaryo: null,

    /** 入れ替え車両の納車先 */
    irekaeNosya: null,

    /** 入れ替え車両の納車先の選択区分 */
    irekaeNosyaActiveKbn: null,

    /** 次へ、更新、登録ボタンのdisabledフラグ */
    isSubmitDisabled: false,

    /** 仮入れ替え車両の納車先 */
    tmpIrekaeNosya: {
      data: null,
      MASTER: {
        data: cloneDeep(HIKINO_SAKI),
        cond: null,
        isSearch: false,
        isValid: false,
      },
      FAVORITE: {
        data: cloneDeep(HIKINO_SAKI),
        cond: null,
        isSearch: false,
        isValid: false,
      },
      DIRECT: {
        data: {
          aa: cloneDeep(HIKINO_SAKI),
          other: cloneDeep(HIKINO_SAKI),
        },
        cond: {
          isAAFlg: 0,
          aa: null,
          other: null,
        },
        isSearch: false,
        isValid: false,
      },
      AUCTION: {
        data: cloneDeep(HIKINO_SAKI),
      },
    },

    /** 車両リスト編集中フラグ */
    isListEdit: false,

    beforeRouteName: '',
    isForceShowSyaryoList: false,

    validScrollId: '',
    // サジェスト設定
    autoCompleteStyle: {
      vueSimpleSuggest: 'position-relative',
      inputWrapper: '',
      defaultInput: 'form-control',
      suggestions: 'position-absolute list-group z-1000',
      suggestItem: 'list-group-item',
    },
    autoCompleteStyleError: {
      vueSimpleSuggest: 'position-relative',
      inputWrapper: '',
      defaultInput: 'form-control border-red',
      suggestions: 'position-absolute list-group z-1000',
      suggestItem: 'list-group-item',
    },
    makerList: [], // 車両メーカ一覧
    syameiList: [], // 車名一覧
    makerSyameiMap: {}, // メーカー、車名マップ
    isShowNPDialog: false,
    picked: null,
    isShowAddedDialog: false, // 車両追加フラグ
    isShowEditedDialog: false,
    idUploaded: false,

    // 搬出券
    dropzoneOptions: {
      url: `${process.env.API.DOMAIN}${Constant.API_URL.IMAGES_ORDER}`,
      thumbnailWidth: 150,
      maxFilesize: 5, //MB
      maxFiles: 1, // ファイル上限数
      headers: { 'My-Awesome-Header': 'header value' },
      addRemoveLinks: true,
      dictCancelUpload: 'キャンセル',
      dictRemoveFile: 'キャンセル',
      dictDefaultMessage:
        "<i class='fa fa-cloud-upload'></i>ファイルを選択してください",
    },

    // その他ファイル
    dropzoneOtherOptions: {
      url: `${process.env.API.DOMAIN}${Constant.API_URL.IMAGES_ORDER_OTHER}`,
      thumbnailWidth: 150,
      maxFilesize: 5, //MB
      maxFiles: 5, // ファイル上限数
      headers: { 'My-Awesome-Header': 'header value' },
      addRemoveLinks: true,
      dictCancelUpload: 'キャンセル',
      dictRemoveFile: 'キャンセル',
      dictDefaultMessage:
        "<i class='fa fa-cloud-upload'></i>ファイルを選択してください",
    },

    search: {
      TODO_CD: '',
      TODO_MEI: '',
      SHIKU_CD: '',
      SHIKU_MEI: '',
    },
    cities: {
      // 市区町村配列
      SKS: [],
      NUMBER_PLATE: [],
      FAVORITE: [],
    },
    numberArea: [], // 登録地域
    form: {}, // 引納データ
    syaryo: { CAR_CONDITIONS: {} }, // 車両データ
    syaryos: [], // 車両リスト登録用データ
    vehicles: [], // 車両リスト表示用データ
    vehicleID: 0, // 車両リスト表示用データID
    transports: [],
    syaryoDefault: {
      MEISAI_BANGO: null,
      SYARYO_STATUS: 0,
      SHITADORI_FLG: null,
      YUSOSAKI_KBN: null,
      YUSOSAKI_FREE: null,
      SOUFUBUTU_KBN: null,
      SYARYO_TYPE_KBN: '',
      SYARYO_TYPE_DETAIL: null,
      SYAKEN_FLG: 0,
      SYARYO_MAKER_MEI: '',
      SYARYO_MEI: '',
      SYADAI_BANGO: null,
      TOUROKU_BANGO: null,
      SHITADORI_SYARYO_TYPE_KBN: null,
      SHITADORI_SYAKEN_FLG: null,
      SHITADORI_SYARYO_MAKER_MEI: null,
      SHITADORI_SYARYO_MEI: null,
      SHITADORI_SYADAI_BANGO: null,
      SHITADORI_TOUROKU_BANGO: null,
      SYARYO_NAGASA: null,
      SYARYO_HABA: null,
      SYARYO_TAKASA: null,
      SYARYO_SEKISAIRYO: null,
      SYARYO_JYURYO: null,
      KISYA_KANRI_BANGO: null,
      SYUPPIN_BANGO: null,
      HANSYUTUKEN_URL: '',
      OTHER_FILE_LIST: [],
      HANNYU_MEI: null,
      ATSUKAI_MEI: null,
      MUKETI_MEI: null,
      JISOU_KBN: 1,
      MEIHEN_KIBO_BI: null,
      MEIHEN_SYAKEN_KBN: null,
      MEIHEN_KEI_FLG: null,
      MEIHEN_UNYU_SIKYOKU_TODO_MEI: null,
      MEIHEN_UNYU_SIKYOKU_SHIKU_MEI: null,
      MEIHEN_UNYU_SIKYOKU_SHIKU_CD: null,
      MEIHEN_TOUROKU_KBN: null,
      MEIHEN_NUMBER_KBN: null,
      MEIHEN_KIBO_NUMBER_FLG: null,
      MEIHEN_KIBO_NUMBER_DAIKO_FLG: null,
      MEIHEN_KIBO_NUMBER: null,
      MEIHEN_KIBO_NUMBER_ZUGARA_FLG: null,
      MEIHEN_KIBO_NUMBER_UKETUKE_BANGO: null,
      MEIHEN_KAZEI_KBN: null,
      MEIHEN_SYOYUSYA_MEI: null,
      MEIHEN_SIYOSYA_MEI: null,
      MEIHEN_SIYOSYA_MEI_KANA: null,
      MEIHEN_SIYOSYA_YUBIN1: null,
      MEIHEN_SIYOSYA_YUBIN2: null,
      MEIHEN_SIYOSYA_TODO_CD: null,
      MEIHEN_SIYOSYA_TODO_MEI: null,
      MEIHEN_SIYOSYA_SHIKU_CD: '',
      MEIHEN_SIYOSYA_SHIKU_MEI: null,
      MEIHEN_SIYOSYA_BANCHI: null,
      MEIHEN_SIYOSYA_TEL: null,
      MEIHEN_SIYOSYA_MAIL_ADDR: null,
      MEIHEN_SYAKOSYO_DAIKO_KBN: null,
      MEIHEN_JIDOSYA_ZEI: null,
      MEIHEN_JIDOSYA_SYUTOKU_ZEI: null,
      MEIHEN_JYURYOU_ZEI: null,
      JYUMINHYO_FLG: null,
      JYUMINHYO_YUBIN1: null,
      JYUMINHYO_YUBIN2: null,
      JYUMINHYO_TODO_CD: null,
      JYUMINHYO_TODO_MEI: null,
      JYUMINHYO_SHIKU_CD: null,
      JYUMINHYO_SHIKU_MEI: null,
      JYUMINHYO_BANCHI: null,
      HANSYUTUKEN: null,
      BIKO: null,
      ETC_SETUP_FLG: null,
      ETC_KANRI_BANGO: null,
      ETC_TOUROKU_BANGO: null,
      SYAKOSYO_JYURYO_FLG: null,
      SYAKOSYO_JYURYO_KBN: null,
      SEISOU_FLG: null,
      SEISOU_KBN: null,
      HOKAN_FLG: null,
      SYAKO_SYODAKUSYO_FLG: null,
      SYAKO_SYODAKUSYO_TORIYOSE_FLG: null,
      SYAKO_SYODAKUSYO_TORIYOSE: null,
      SYAKO_SYODAKUSYO_CHUSYAJYO_KEIYAKU_MEI: null,
      SYAKO_SYODAKUSYO_CHUSYAJYO_MEI: null,
      SYAKO_SYODAKUSYO_CHUSYAJYO_BANGO: null,
      SYAKO_SYODAKUSYO_YUBIN1: null,
      SYAKO_SYODAKUSYO_YUBIN2: null,
      SYAKO_SYODAKUSYO_TODO_CD: null,
      SYAKO_SYODAKUSYO_TODO_MEI: null,
      SYAKO_SYODAKUSYO_SHIKU_CD: null,
      SYAKO_SYODAKUSYO_SHIKU_MEI: null,
      SYAKO_SYODAKUSYO_BANCHI: null,
      SYAKO_SYODAKUSYO_TEL: null,
      NUMBER_PLATE_FLG: 0,
      NUMBER_PLATE_MEI: null,
      NUMBER_PLATE_YUBIN1: null,
      NUMBER_PLATE_YUBIN2: null,
      NUMBER_PLATE_TODO_CD: '',
      NUMBER_PLATE_TODO_MEI: null,
      NUMBER_PLATE_SHIKU_CD: '',
      NUMBER_PLATE_SHIKU_MEI: null,
      NUMBER_PLATE_BANCHI: null,
      NUMBER_PLATE_SAKI_TEL: null,
      IREKAE_FLG: 0,
      SYARYO_SHAPE_TYPE: null,
      SYARYO_SHAPE_DETAIL: null,
      CAR_CONDITIONS: {
        is_self_run: 1,
        is_self_run_detail: null,
        is_self_run_detail_other: null,
        is_roll_tire: null,
        is_run_engine: null,
        is_studless: 1,
        is_run_air_conditioner: 1,
        is_custom: 0,
        is_custom_details: [],
        is_custom_detail_other: null,
        minimum_height: null,
        inch_up: null,
        is_expensive: 0,
        price: null,
        is_classic: 0,
        model_year: null,
        fuel_type: null,
      },
      torokubango1: '',
      torokubango2: null,
      torokubango3: null,
      torokubango4: null,
    },
    option: {
      HOKAN_FLG: null,
      YOUBOU: null,
    },

    // 車両画面で不具合が発生することがあるため、操作ログを取得し発注時にサーバ側に送る
    operationLog: [],
  }),

  methods: {
    /** 車両に表示された入力データのみ設定する */
    async cleanupSyaryo(syaryo) {
      this.addOperationLog('cleanupSyaryo', { syaryo })
      await this.sleep(500)

      // 車名は必須入力のため絶対に入力されてなければならない
      // 車名が空の場合は、データが反映されてない可能性があるため取得できるまでしばらく待つ
      const maxCount = 50
      let count = 0
      while (!this.$refs.SYARYO_MEI && count < maxCount) {
        await this.sleep(100)
        count++
      }

      // 5秒待っても車名が取得できない場合は、発注データが壊れているためアラートを表示する
      if (count === maxCount) {
        // エラー時の車両データ状況を知りたいためサーバーに送る
        Store.dispatch('util/logging', {
          title: 'IS_FAILURE_SYARYO Vehicle.vue',
          subTitle: 'jyuchu-add-vehicle',
          message: 'Exception:cleanupSyaryo Error',
          type: 'error',
          data: cloneDeep(this.operationLog),
        })
        this.isShowErrorDialog = true
        return
      }

      this.observer.reset()

      let d = {}
      for (const name in this.syaryoDefault) {
        if (name === 'CAR_CONDITIONS') {
          const conditionsRef = this.$refs.syaryo_conditions.getRefs()
          d.CAR_CONDITIONS = {}
          for (const conditionName in this.syaryoDefault.CAR_CONDITIONS) {
            if (conditionsRef[conditionName]) {
              d.CAR_CONDITIONS[conditionName] =
                syaryo.CAR_CONDITIONS[conditionName]
            }
          }
        } else {
          const refs = [this.$refs, this.$refs.syaryo_type_detail.getRefs()]
          refs.forEach((ref) => {
            if (ref[name]) {
              d[name] = syaryo[name]
            }
          })
        }
      }
      if (syaryo.irekae && Number(d['IREKAE_FLG'])) d['irekae'] = syaryo.irekae
      if (syaryo.ID) d['ID'] = syaryo.ID
      if (syaryo.isMitumori) d['isMitumori'] = syaryo.isMitumori
      if (syaryo.IRAI_JYUCHU_ID) d['IRAI_JYUCHU_ID'] = syaryo.IRAI_JYUCHU_ID
      if (syaryo.IREKAE_SYARYO_ID)
        d['IREKAE_SYARYO_ID'] = syaryo.IREKAE_SYARYO_ID
      return d
    },

    /** オプションに表示された入力データのみ設定する */
    cleanupOption(option) {
      this.addOperationLog('cleanupOption', { option })
      let d = {}
      for (var name in this.option) {
        if (this.$refs[name]) d[name] = option[name]
      }
      return d
    },

    // 戻る
    handleBackButtonClick() {
      this.form.syaryo = this.syaryo
      this.form.syaryos = this.syaryos
      this.form.option = this.option
      const params = {
        yusoKbn: this.form.MEIHEN_FLG,
        form: this.form,
      }
      this.$router.push({ name: 'OrderTransport', params })
    },

    handleTempSaveButtonInModalClick() {
      this.form.syaryo = this.syaryo
      this.form.syaryos = this.syaryos
      this.form.option = this.option
      saveTempData('vehicle', this.form)
    },

    /** 車両リストのバリデーションを行う */
    async syaryoListValid() {
      this.addOperationLog('syaryoListValid')
      for (const syaryo of this.syaryos) {
        this.syaryo = cloneDeep(syaryo)
        await this.sleep(50)
        let result = await this.observer.validate()
        let message = `入力項目にエラーがあります。`
        // 入れ替え車両チェック
        if (result && syaryo.irekae) {
          result = await this.irekaeSyaryoValid(syaryo.irekae)
          let message = `下取/入れ替え車両にエラーがあります。`
        }

        if (!result) {
          this.isErrSyaryoList = true
          Store.commit('vehicle/setEditId', syaryo.id)
          this._alert(message)
          return false
        }
      }
      return true
    },

    /** 表示中の1車両のバリデーションを行う */
    async syaryoValid() {
      this.addOperationLog('syaryoValid')
      let message = `入力項目にエラーがあります。`
      if (await this.observer.validate()) {
        // 入れ替え車両チェック
        if (!this.syaryo.irekae) return true
        else if (await this.irekaeSyaryoValid(this.syaryo.irekae)) return true
        let message = `下取/入れ替え車両にエラーがあります。`
      }

      this.syaryos.length
        ? (this.isForceNextConfirm = true)
        : this._alert(message)
      return false
    },

    /** 入れ替え車両のバリデーションを行う */
    async irekaeSyaryoValid(irekae) {
      this.addOperationLog('irekaeSyaryoValid', { irekae })
      this.tmpForm = cloneDeep(this.form)
      this.tmpSyaryo = cloneDeep(this.syaryo)
      this.form = cloneDeep(irekae)
      this.syaryo = cloneDeep(irekae.syaryo)
      await this.sleep(50)
      const result = await this.observer.validate()
      this.form = cloneDeep(this.tmpForm)
      this.syaryo = cloneDeep(this.tmpSyaryo)
      return result
    },

    /** 確認画面遷移の事前処理 */
    async beforeNext(nextFlg = false) {
      this.addOperationLog('beforeNext', { nextFlg })
      this.isSubmitDisabled = true
      if (
        !this.form.isFromHistoryEdit &&
        Number(this.syaryo.IREKAE_FLG) &&
        !this.syaryo.irekae
      ) {
        await this.changeIrekaeMode()
      } else {
        await this.next(nextFlg)
      }
      this.isSubmitDisabled = false
    },

    /**
     * 確認画面へ
     * @param  {Boolean} [isSyaryoValidSkip=false] 車両バリデーションスキップフラグ
     */
    async next(isSyaryoValidSkip = false) {
      this.addOperationLog('next', { isSyaryoValidSkip })
      this.spinerOff()

      if (this.isEnableInvoice) {
        // 請求先バリデーション実行
        this.isInvoiceValidActive = true
        await this.sleep(100)
      } else {
        // 請求不可能な取引先は請求バリデーションフラグをtrueにする
        this.isInvoiceValid = true
      }

      const syaryo = this.syaryo
      if (
        !(
          (isSyaryoValidSkip || (await this.syaryoValid())) &&
          (await this.syaryoListValid()) &&
          this.isInvoiceValid
        )
      ) {
        if (!this.isInvoiceValid) this._alert('入力項目にエラーがあります。')
        return
      }

      if (!isSyaryoValidSkip) {
        this.syaryo = syaryo
        await this.addVehicle(true)
        this.$store.commit('vehicle/changeDisplayButtomElem', false)
      }

      this.spinerOn()
      const option = this.cleanupOption(this.option)
      this.form.syaryos = []
      for (let v of this.syaryos) {
        this.syaryo = cloneDeep(v)
        let syaryo = await this.cleanupSyaryo(this.syaryo)
        if (!syaryo) return

        syaryo = merge(syaryo, option)
        if (syaryo.irekae) merge(syaryo.irekae.syaryo, option)
        this.form.syaryos.push(syaryo)
      }

      this.form.option = option
      this.form.isNosyaYard = this.isNosyaYard
      this.spinerOff()

      /*
      Store.dispatch('util/logging', {
        title: 'order_operation_log',
        subTitle: 'next',
        message: '',
        type: 'info',
        data: cloneDeep(this.operationLog),
      })
      */

      this.$router.push({ name: 'OrderConfirm', params: { form: this.form } })
    },

    /**
     * 請求先バリデーション発火フラグをセットする
     */
    setIsInvoiceValidActive() {
      this.isInvoiceValidActive = false
    },
    /**
     * 請求先バリデーション結果フラグをセットする
     * @param Boolean isInvoiceValid
     */
    setIsInvoiceValid(isValid) {
      this.isInvoiceValid = isValid
    },
    /**
     * formデータをマージする
     * @param form form
     */
    setInvoice(form) {
      this.form = merge(this.form, form)
    },

    // データ初期化
    setDefaultData() {
      this.addOperationLog('setDefaultData')
      // 搬出券
      if (
        this.$refs.HANSYUTUKEN_URL !== undefined &&
        this.$refs.HANSYUTUKEN_URL.dropzone.files.length > 0
      ) {
        this.$refs.HANSYUTUKEN_URL.removeAllFiles()
      }

      // その他ファイル
      if (
        this.$refs.OTHER_FILE_LIST !== undefined &&
        this.$refs.OTHER_FILE_LIST.dropzone.files.length > 0
      ) {
        this.$refs.OTHER_FILE_LIST.removeAllFiles()
      }

      this.syaryo = cloneDeep(this.syaryoDefault)
    },

    /** ナンバープレート都道府県変更 */
    async changeNPPref() {
      const todoCd = this.syaryo.NUMBER_PLATE_TODO_CD
      this.syaryo.NUMBER_PLATE_TODO_MEI = null
      this.syaryo.NUMBER_PLATE_SHIKU_CD = ''
      this.syaryo.NUMBER_PLATE_SHIKU_MEI = null
      if (todoCd) {
        this.syaryo.NUMBER_PLATE_TODO_MEI = this.getText(this.prefList, todoCd)
        this.nPCityList = await this.getCityList(todoCd)
      } else this.nPCityList = []
    },

    /** ナンバープレート市区町村変更 */
    changeNPCity() {
      const shikuCd = this.syaryo.NUMBER_PLATE_SHIKU_CD
      this.syaryo.NUMBER_PLATE_SHIKU_MEI = null
      if (shikuCd) {
        this.syaryo.NUMBER_PLATE_SHIKU_MEI = this.getText(
          this.nPCityList,
          shikuCd
        )
      }
    },

    /** ナンバープレート郵便番号検索 */
    searchNPZip() {
      this.getAreaFromZipCd(
        `${this.syaryo.NUMBER_PLATE_YUBIN1}${this.syaryo.NUMBER_PLATE_YUBIN2}`
      ).then(async (item) => {
        if (item) {
          this.syaryo.NUMBER_PLATE_TODO_CD = ('00' + item.prefcode).slice(-2)
          this.syaryo.NUMBER_PLATE_TODO_MEI = this.getText(
            this.prefList,
            this.syaryo.NUMBER_PLATE_TODO_CD
          )
          this.syaryo.NUMBER_PLATE_SHIKU_MEI = item.address2
          this.syaryo.NUMBER_PLATE_BANCHI = item.address3
          this.nPCityList = await this.getCityList(
            this.syaryo.NUMBER_PLATE_TODO_CD
          )
          this.setNPShikuCd(this.syaryo.NUMBER_PLATE_SHIKU_MEI)
        }
      })
    },

    /** 名前からナンバープレート市区町村CDを設定する */
    setNPShikuCd(name) {
      const city = this.getParam(this.nPCityList, name, 'text')
      if (city) this.syaryo.NUMBER_PLATE_SHIKU_CD = city.value
    },

    /** 市区町村リスト取得 */
    getCityList(todoCd) {
      return Store.dispatch('address/getCityList', todoCd).then(() => {
        const cityList = cloneDeep(Store.state.address.cityList)
        cityList.unshift({
          value: '',
          text: '未選択',
        })
        return cityList
      })
    },

    /**
     * 都道府県選択時の処理
     * @param  {string} paramName パラメータ名
     */
    async changePrefFavor(shikuInit = true) {
      const prefCd = this.search.TODO_CD
      if (shikuInit) this.search.SHIKU_CD = ''
      this.transports = []
      this.cities.FAVORITE = {}
      if (prefCd) await this.setCities(prefCd, 'FAVORITE', this.cities)
      await this.getNumberPlate(prefCd)
    },

    /** ナンバープレート履歴の市区町村選択時の処理 */
    async searchNumberPlateCity() {
      const prefCd = this.search.TODO_CD
      const shikuCd = this.search.SHIKU_CD
      this.selectedTableInitial()
      this.getNumberPlate(prefCd, shikuCd)
    },

    getNumberPlate(prefCd = null, shikuCd = null) {
      return this.getNumberPlateOkiniiri({ prefCd, shikuCd }).then((res) => {
        this.transports = res.data
      })
    },

    /** 入れ替え車両追加 */
    async addIrekaeVehicle() {
      this.addOperationLog('addIrekaeVehicle')
      this.isSubmitDisabled = true
      const isNoError = await this.observer.validate()
      if (!isNoError) {
        this.isSubmitDisabled = false
        return this._alert('入力項目にエラーがあります。')
      }
      this.observer.reset()

      let irekaeForm = cloneDeep(this.form)
      const irekaesSyaryo = await this.cleanupSyaryo(this.syaryo)
      irekaeForm.syaryo = irekaesSyaryo
      let syaryo = cloneDeep(this.tmpSyaryo)
      syaryo.irekae = irekaeForm
      this.syaryo = cloneDeep(syaryo)

      this.isIrekae = false
      this.form = cloneDeep(this.tmpForm)
      if (this.syaryos.length && !this.isListEdit) await this.addVehicle(true)

      await this.sleep(50)
      this.addFileToS3()

      this.isShowIrekaedDialog = true
      this.isSubmitDisabled = false
      firstScrollTo('#syaryo-top')
    },

    /** 入れ替え車入力キャンセル */
    async cancelIrekaeVehicle() {
      this.addOperationLog('cancelIrekaeVehicle')
      this.isIrekae = false
      this.form = cloneDeep(this.tmpForm)
      this.syaryo = cloneDeep(this.tmpSyaryo)
      // await this.sleep(100)
      // this.addFileToS3()
      this.syaryo.IREKAE_FLG = 0
      this.syaryo.irekae = null
      this.irekaeNosya = null
      firstScrollTo('#syaryo-top')
    },

    /** 入れ替え車両編集モードに変更する */
    async changeIrekaeMode() {
      this.addOperationLog('changeIrekaeMode')
      const isNoError = await this.observer.validate()
      if (!isNoError) return this._alert('入力項目にエラーがあります。')
      this.observer.reset()

      this.tmpSyaryo = cloneDeep(this.syaryo)
      this.tmpForm = cloneDeep(this.form)
      if (this.syaryo.irekae) {
        this.form = cloneDeep(this.syaryo.irekae)
        this.syaryo = cloneDeep(this.syaryo.irekae.syaryo)
        await this.sleep(100)
        this.addFileToS3()
        this.isShowIrekaeDialog = true
      } else {
        this.isShowIrekaeNosyaDialog = true
        this.setDefaultData()
      }

      this.isIrekae = true
      firstScrollTo('#syaryo-top')
    },

    /** 入れ替え車両編集を行わない */
    notEditIrekaeVehicle() {
      this.addOperationLog('notEditIrekaeVehicle')
      this.editEnd()
      firstScrollTo('#syaryo-top')
    },

    /**
     * 車両リスト更新
     * @return {Promise} [description]
     */
    async updateVehicle() {
      this.isSubmitDisabled = true
      await this.addVehicle(false)
      this.isSubmitDisabled = false
    },

    /** 車両リスト追加 */
    async addVehicle(isAlertSkip) {
      this.addOperationLog('addVehicle', { isAlertSkip })
      let result = true

      const isNoError = await this.observer.validate()
      if (!isNoError) {
        this._alert('入力項目にエラーがあります。')
        return !result
      }
      this.observer.reset()

      const syaryo = await this.cleanupSyaryo(this.syaryo)

      // 発注車両リストへデータ追加
      syaryo.id = this.vehicleID
      this.syaryos.push(syaryo)

      // 車両リストへデータ追加
      this.vehicles.push({
        id: this.vehicleID,
        name: syaryo.SYARYO_MEI,
        number: syaryo.SYADAI_BANGO || syaryo.TOUROKU_BANGO,
        isShowDelBtn: syaryo.ID === undefined,
      })
      Store.commit('vehicle/update', this.vehicles)
      this.vehicleID++

      this.setDefaultData()
      if (isAlertSkip) return result

      if (this.isListEdit) this.editEnd()
      else this.isShowAddedDialog = true

      firstScrollTo('#syaryo-top')
      return result
    },

    /** 編集完了時 */
    editEnd() {
      this.addOperationLog('editEnd')
      this.isShowEditedDialog = true
      this.isListEdit = false
    },

    // 車両データを持ってる状態で画面遷移した場合に、リストに追加する処理
    _addVehicle: function (syaryo) {
      this.addOperationLog('_addVehicle', { syaryo })
      // 発注車両リストへデータ追加
      syaryo.id = this.vehicleID
      this.syaryos.push(syaryo)
      // 車両リストへデータ追加
      this.vehicles.push({
        id: this.vehicleID,
        name: syaryo.SYARYO_MEI,
        number: syaryo.SYADAI_BANGO || syaryo.TOUROKU_BANGO,
        isShowDelBtn: syaryo.ID === undefined,
      })
      Store.commit('vehicle/update', this.vehicles)
      this.vehicleID++
    },

    /** 登録番号設定 */
    async onChangeTorokubango() {
      await this.observer.refs.torokubango1.validate()
      await this.observer.refs.torokubango2.validate()
      await this.observer.refs.torokubango3.validate()
      await this.observer.refs.torokubango4.validate()
      if (!this.isInvalidTorokuBnago)
        this.syaryo.TOUROKU_BANGO = `${this.syaryo.torokubango1} ${this.syaryo.torokubango2} ${this.syaryo.torokubango3} ${this.syaryo.torokubango4}`
      else this.syaryo.TOUROKU_BANGO = null
    },

    // 登録地域取得
    setNumberArea() {
      this.getNumberArea().then((res) => {
        this.numberArea = res.data.map((v) => {
          return {
            value: v.NUMBER_CHIMEI,
            text: v.NUMBER_CHIMEI,
          }
        })
        this.numberArea.unshift({
          value: '',
          text: '未選択',
        })
      })
    },

    // メーカー一覧、車名マップのサジェストデータセット
    setSyaryoMaker() {
      this.getSyaryoMakerList()
        .then((res) => {
          for (const item of res.data) {
            this.makerList.push(item.MAKER_MEI)
            const list = []
            for (const item2 of item.kensaku_syamei) {
              list.push(item2.SYAMEI)
            }
            this.makerSyameiMap[item.MAKER_MEI] = list
          }
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // 車名一覧データ設定
    setSyameiList() {
      this.addOperationLog('setSyameiList')
      this.syameiList = []
      // 普通車の場合のみ車名サジェストを行う
      const syaryoType = this.syaryo.SYARYO_TYPE_KBN
      if (Number(syaryoType) === 1) {
        const maker = this.syaryo.SYARYO_MAKER_MEI
        this.syameiList = this.makerSyameiMap[maker] || []
      }
    },
    // 車両リストから削除
    deleteSyaryo(id) {
      this.addOperationLog('deleteSyaryo', { id })
      const vehicles = []
      for (const index in this.vehicles) {
        const item = this.vehicles[index]
        if (item.id !== id) {
          vehicles.push(item)
        }
      }
      this.vehicles = vehicles

      // 車両登録リストから削除
      const syaryos = []
      for (const index in this.syaryos) {
        const item = this.syaryos[index]
        if (item.id !== id) {
          syaryos.push(item)
        }
      }
      this.syaryos = syaryos

      // ストア更新
      Store.commit('vehicle/update', this.vehicles)
    },

    ////// 搬出券 ///////////
    vfileSend() {
      this.spinerOn()
    },
    /** アップロード完了時にURLを格納する */
    vfileSent(file) {
      this.spinerOff()
      this.scroll('clear')
      this.syaryo.HANSYUTUKEN_URL = file.xhr.response
      this.syaryo.HANSYUTUKEN = file
      this.isUploaded = true
    },
    removeFile(file) {
      this.syaryo.HANSYUTUKEN_URL = ''
    },
    /////////////////////////

    ////// その他ファイル /////
    vfileOtherSend() {
      this.spinerOn()
    },
    /** アップロード完了時にURLを格納する */
    vfileOtherSent(file) {
      this.spinerOff()
      this.scroll('clear')
      this.syaryo.OTHER_FILE_LIST.push(file)
    },
    removeOtherFile(file) {
      this.syaryo.OTHER_FILE_LIST = this.syaryo.OTHER_FILE_LIST.filter(
        (v) => v.xhr.response !== file.xhr.response
      )
    },
    addedOtherFile(file) {
      const conds = [
        'image/jpeg',
        'image/png',
        'application/pdf',
        'image/gif',
        'image/bmp',
      ]
      if (!conds.includes(file.type)) {
        this._alert(
          '.jpg .bmp .gif .pdf .pngのファイルをアップしてください',
          false
        )
        this.$refs.OTHER_FILE_LIST.removeFile(file)
      }
    },
    /////////////////////////

    async setLastJyucyu() {
      this.addOperationLog('setLastJyucyu')
      return this.getLastJyucyu({ MEIHEN_FLG: this.form.MEIHEN_FLG })
    },

    addFileToS3() {
      const add = (file, dropRef) => {
        dropRef.manuallyAddFile(file)
        if (!file.type.match(/pdf/)) {
          dropRef.dropzone.emit('thumbnail', file, file.dataURL)
        }
        dropRef.dropzone.emit('complete', file)
      }

      // 搬出券
      if (this.syaryo.HANSYUTUKEN_URL) {
        add(this.syaryo.HANSYUTUKEN, this.$refs.HANSYUTUKEN_URL)
      }

      // その他ファイル
      if (this.syaryo.OTHER_FILE_LIST.length > 0) {
        this.syaryo.OTHER_FILE_LIST.forEach((file) => {
          add(file, this.$refs.OTHER_FILE_LIST)
        })
      }
    },

    async addVehicleAndEdit() {
      this.addOperationLog('addVehicleAndEdit')
      if (await this.addVehicle(true)) this.editSyaryo()
      else Store.commit('vehicle/setEditId', '')
    },
    editSyaryo() {
      this.addOperationLog('editSyaryo')
      const id = Store.state.vehicle.editId
      if (id !== '') {
        this.isListEdit = true
        for (const index in this.syaryos) {
          const item = this.syaryos[index]
          if (item.id === id) {
            this.syaryo = item
            this.setCities(
              item.NUMBER_PLATE_TODO_CD,
              'NUMBER_PLATE',
              this.cities
            )
            this.addFileToS3()
            break
          }
        }
        this.deleteSyaryo(id)
        firstScrollTo('#syaryo-top')
      }
    },

    /** 履歴がらナンバープレート選択 */
    async selectNP(syaryo) {
      this.syaryo.NUMBER_PLATE_YUBIN1 = syaryo.YUBIN1
      this.syaryo.NUMBER_PLATE_YUBIN2 = syaryo.YUBIN2
      this.syaryo.NUMBER_PLATE_TODO_CD = syaryo.TODO_CD
      this.syaryo.NUMBER_PLATE_TODO_MEI = syaryo.TODO_MEI
      this.syaryo.NUMBER_PLATE_SHIKU_CD = syaryo.SHIKU_CD
      this.syaryo.NUMBER_PLATE_SHIKU_MEI = syaryo.SHIKU_MEI
      this.syaryo.NUMBER_PLATE_BANCHI = syaryo.BANCHI
      this.syaryo.NUMBER_PLATE_MEI = syaryo.MEI
      this.syaryo.NUMBER_PLATE_SAKI_TEL = syaryo.TEL
      this.syaryo.NUMBER_PLATE_FAX = syaryo.FAX
      this.nPCityList = await this.getCityList(syaryo.TODO_CD)
    },

    /** ナンバープレートに設定した値を設定する */
    setNP(syaryo) {
      return {
        NUMBER_PLATE_FLG: syaryo.NUMBER_PLATE_FLG,
        NUMBER_PLATE_YUBIN1: syaryo.NUMBER_PLATE_YUBIN1,
        NUMBER_PLATE_YUBIN2: syaryo.NUMBER_PLATE_YUBIN2,
        NUMBER_PLATE_TODO_CD: syaryo.NUMBER_PLATE_TODO_CD,
        NUMBER_PLATE_TODO_MEI: syaryo.NUMBER_PLATE_TODO_MEI,
        NUMBER_PLATE_SHIKU_CD: syaryo.NUMBER_PLATE_SHIKU_CD,
        NUMBER_PLATE_SHIKU_MEI: syaryo.NUMBER_PLATE_SHIKU_MEI,
        NUMBER_PLATE_BANCHI: syaryo.NUMBER_PLATE_BANCHI,
        NUMBER_PLATE_MEI: syaryo.NUMBER_PLATE_MEI,
        NUMBER_PLATE_SAKI_TEL: syaryo.NUMBER_PLATE_SAKI_TEL,
        NUMBER_PLATE_FAX: syaryo.NUMBER_PLATE_FAX,
      }
    },

    /** ナンバープレートに所属する取引先情報を設定する */
    setNPFromTorihki() {
      const torihiki = Store.state.user.data.hum_torihiki
      return {
        NUMBER_PLATE_YUBIN1: torihiki.TORIHIKI_YUBIN1,
        NUMBER_PLATE_YUBIN2: torihiki.TORIHIKI_YUBIN2,
        NUMBER_PLATE_TODO_CD: this.getParam(
          this.prefList,
          torihiki.TORIHIKI_TODO_MEI,
          'text'
        ).value,
        NUMBER_PLATE_TODO_MEI: torihiki.TORIHIKI_TODO_MEI,
        NUMBER_PLATE_SHIKU_CD: torihiki.TORIHIKI_SHIKU_CD,
        NUMBER_PLATE_SHIKU_MEI: torihiki.TORIHIKI_SHIKU_MEI,
        NUMBER_PLATE_BANCHI: torihiki.TORIHIKI_BANCHI,
        NUMBER_PLATE_MEI: torihiki.SOFU_SAKI_MEI,
        NUMBER_PLATE_SAKI_TEL: torihiki.TORIHIKI_SAKI_TEL,
        NUMBER_PLATE_FAX: torihiki.TORIHIKI_SAKI_FAX,
      }
    },

    /** 初期値を生成する */
    async makeDefaultData() {
      this.addOperationLog('makeDefaultData')
      let d = this.syaryoDefault

      // ナンバープレートの初期値設定
      let numberPlate = {}
      await Store.dispatch('order/getLatestSyaryo')
        .then((res) => {
          numberPlate = Number(res.data.NUMBER_PLATE_FLG)
            ? this.setNP(res.data)
            : this.setNPFromTorihki()
        })
        .catch(() => {
          numberPlate = this.setNPFromTorihki()
        })
      d = merge(d, numberPlate)

      // 納車ヤード初期値設定
      if (this.isNosyaYard) {
        await this.setLastJyucyu().then((res) => {
          const d = res.data
          if (d) {
            d.HANNYU_MEI = d.HANNYU_MEI
            d.ATSUKAI_MEI = d.ATSUKAI_MEI
          }
        })
      }

      // リース会社の場合
      if (this.isLease) {
        d.JISOU_KBN = 1
        d.SEISOU_FLG = 0
        d.SEISOU_KBN = 12
        this.option.HOKAN_FLG = this.isNosyaHokanYard ? 1 : 0
      }
    },

    /** デフォルト車両と指定車両をマージする */
    syaryoDefaultMerge(syaryo) {
      this.addOperationLog('syaryoDefaultMerge', { syaryo })
      let d = cloneDeep(syaryo)
      for (const name in this.syaryoDefault) {
        if (d[name] === undefined) {
          d[name] = this.syaryoDefault[name]
          continue
        }

        if (name === 'CAR_CONDITIONS') {
          for (const carConditionName in this.syaryoDefault.CAR_CONDITIONS) {
            if (d.CAR_CONDITIONS[carConditionName] === undefined) {
              d.CAR_CONDITIONS[carConditionName] =
                this.syaryoDefault.CAR_CONDITIONS[carConditionName]
            }
          }
        }
      }

      return d
    },

    /** 下部の車両リストを表示する */
    showButtomList() {
      this.$store.commit('vehicle/changeDisplayButtomElem', true)
    },

    /** 下部の車両リストを非表示にする */
    hideButtomList() {
      this.$store.commit('vehicle/changeDisplayButtomElem', false)
    },

    /** 入れ替え車両納車先登録場所Dialog表示 */
    async showMasterDialog() {
      this.addOperationLog('showMasterDialog')
      this.isShowIrekaeNosyaDialog = false
      this.isShowMasterDialog = true
      const nosya = this.irekaeNosya
      if (nosya && this.irekaeNosyaActiveKbn === 'MASTER') {
        this.tmpIrekaeNosya.MASTER.cond = {
          ID: nosya.TOROKUBAYO_KO_ID,
          TODO_CD: nosya.TODO_CD,
          SHIKU_CD: nosya.SHIKU_CD,
        }
      }
      await this.sleep(100)
      this.tmpIrekaeNosya.MASTER.isSearch = true
    },

    /** 入れ替え車両納車先直接場所を指定Dialog表示 */
    async showDirectDialog() {
      this.addOperationLog('showDirectDialog')
      this.isShowIrekaeNosyaDialog = false
      this.isShowDirectDialog = true
      const nosya = this.irekaeNosya
      if (nosya && this.irekaeNosyaActiveKbn === 'DIRECT') {
        this.tmpIrekaeNosya.DIRECT.cond.isAAFlg = 0
        this.tmpIrekaeNosya.DIRECT.cond.other = cloneDeep(nosya)
      }
      if (nosya && this.irekaeNosyaActiveKbn === 'AUCTION') {
        this.tmpIrekaeNosya.DIRECT.cond.isAAFlg = 1
        this.tmpIrekaeNosya.DIRECT.cond.aa = {
          AA_ID: nosya.AA_ID,
          AA_CD: nosya.AA_CD,
          TODO_CD: nosya.TODO_CD,
        }
      }
      await this.sleep(100)
      this.tmpIrekaeNosya.DIRECT.isSearch = true
    },

    /** 入れ替え車両納車先お気に入りの場所Dialog表示 */
    async showFavoriteDialog() {
      this.addOperationLog('showFavoriteDialog')
      this.isShowIrekaeNosyaDialog = false
      this.isShowFavoriteDialog = true
      const nosya = this.irekaeNosya
      if (nosya && this.irekaeNosyaActiveKbn === 'FAVORITE') {
        this.tmpIrekaeNosya.FAVORITE.cond = {
          ID: nosya.FAVORITE_ID,
          TODO_CD: nosya.TODO_CD,
          SHIKU_CD: nosya.SHIKU_CD,
        }
      }
      await this.sleep(100)
      this.tmpIrekaeNosya.FAVORITE.isSearch = true
    },

    /** 入れ替え車の入力データを設定する */
    setIrekaeForm({ nPlace, nOther }) {
      this.addOperationLog('setIrekaeForm', { nPlace, nOther })
      let irekaeForm = cloneDeep(IREKAE_FORM)

      // 引取先、選択タブ
      const form = this.tmpForm || this.form
      merge(irekaeForm, {
        ACTIVE_HIKITORI_TAB: form.ACTIVE_NOSYA_TAB,
        ACTIVE_NOSYA_TAB: this.irekaeNosyaActiveKbn,
        HIKITORI_MASTER: cloneDeep(form.NOSYA_MASTER),
        HIKITORI_FAVORITE: cloneDeep(form.NOSYA_FAVORITE),
        HIKITORI_DIRECT: cloneDeep(form.NOSYA_DIRECT),
        HIKITORI_AUCTION: cloneDeep(form.NOSYA_AUCTION),
        HIKITORI_AA_FLG: form.NOSYA_AA_FLG,
        HIKITORI_AA_WANPULA_FLG: null,
        HIKITORI_AA_WANPULA_RAKUSATU_BI: null,
        HIKITORI_AA_RYUSATU_SYARYO: null,
        HIKITORI_AA_POS_BANGO: null,
        HIKITORI_AA_NYUKIN_JYOKYO_KBN: '',
        HIKITORI_AA_NYUKIN_YOTEI_BI: null,
        HIKITORI_AA_NYUKIN_YOTEI_JIKAN: '',
        HIKITORI_AA_HANSHUTU_KANOU_BI: null,
        HIKITORI_AA_KAISAI_BI: null,
        HIKITORI_AA_POS_KBN: null,
        HIKITORI_AA_POS_DAIKO_GYOSHA_MEI: null,
        HIKITORI_AA_POS_MEIGI_INFO: null,
        HIKITORI_AA_POS_RAKUSATU_SYUPPIN: null,
        HIKITORI_KIBOU_BI: form.NOSYA_KIBOU_BI,
        HIKITORI_KIBOU_BI_TYPE: form.NOSYA_KIBOU_BI_TYPE,
        HIKITORI_KIBOU_JIKAN_TYPE: form.NOSYA_KIBOU_JIKAN_TYPE,
        HIKITORI_KIBOU_JIKAN_REASON: form.NOSYA_KIBOU_JIKAN_REASON,
        HIKITORI_JIZEN_RENRAKU_FLG: form.NOSYA_JIZEN_RENRAKU_FLG,
      })

      // 納車先場所情報
      if (nPlace) {
        let form = {}
        form[`NOSYA_${this.irekaeNosyaActiveKbn}`] = nPlace
        merge(irekaeForm, form, {
          NOSYA_AA_FLG: nPlace.AA_CD ? 1 : 0,
        })
      }

      // 納車先付属情報
      if (nOther) {
        merge(irekaeForm, {
          NOSYA_AA_KAISAI_BI: nOther.NOSYA_AA_KAISAI_BI,
          NOSYA_AA_POS_BANGO: nOther.NOSYA_AA_POS_BANGO,
          NOSYA_AA_SYUPPIN_MEI: nOther.NOSYA_AA_SYUPPIN_MEI,
          NOSYA_AA_KAIJYO_TANTO_MEI: nOther.NOSYA_AA_KAIJYO_TANTO_MEI,
          NOSYA_AA_POS_KBN: nOther.NOSYA_AA_POS_KBN,
          NOSYA_AA_POS_DAIKO_GYOSHA_MEI: nOther.NOSYA_AA_POS_DAIKO_GYOSHA_MEI,
          NOSYA_AA_POS_MEIGI_INFO: nOther.NOSYA_AA_POS_MEIGI_INFO,
          NOSYA_AA_POS_RAKUSATU_SYUPPIN: nOther.NOSYA_AA_POS_RAKUSATU_SYUPPIN,
          NOSYA_KIBOU_BI: nOther.NOSYA_KIBOU_BI,
          NOSYA_KIBOU_BI_TYPE: nOther.NOSYA_KIBOU_BI_TYPE,
          NOSYA_KIBOU_JIKAN_TYPE: nOther.NOSYA_KIBOU_JIKAN_TYPE,
          NOSYA_KIBOU_JIKAN_REASON: nOther.NOSYA_KIBOU_JIKAN_REASON,
          NOSYA_JIZEN_RENRAKU_FLG: nOther.NOSYA_JIZEN_RENRAKU_FLG,
          NOSYA_BIKOU: nOther.NOSYA_BIKOU,
        })
      }

      this.form = merge(this.form, irekaeForm)
    },

    /** 納車先詳細を設定する */
    onSetNosyaDetail(val) {
      this.addOperationLog('onSetNosyaDetail', { val })
      if (val) {
        this.isShowNosyaDetailDialog = false
        this.irekaeNosya = this.tmpIrekaeNosya.data
        this.setIrekaeForm({ nPlace: this.irekaeNosya, nOther: val })
      }
      this.isGetNosyaDetail = false
    },

    /** 入れ替え車納車先検索終了 */
    onSetIrekaeNosyaIsSearch(kbn) {
      this.addOperationLog('onSetIrekaeNosyaIsSearch', { kbn })
      this.tmpIrekaeNosya[kbn].isSearch = false
    },

    /** 入れ替え車納車先設定 */
    onSetIrekaeNosya(val, kbn) {
      this.addOperationLog('onSetIrekaeNosya', { val, kbn })
      this.tmpIrekaeNosya[kbn].data = val
      this.form.ACTIVE_NOSYA_TAB = kbn
      merge(this.form[`NOSYA_${kbn}`], val)
    },

    /** 入れ替え車バリデーション結果設定 */
    onSetIrekaeNosyaInvalid(val, kbn, isAuction = 0) {
      this.addOperationLog('onSetIrekaeNosya', { val, kbn, isAuction })
      this.isIrekaeNosyaInvalid = !val
      this.tmpIrekaeNosya[kbn].isValid = false
      if (!val) {
        kbn = isAuction ? 'AUCTION' : kbn
        this.irekaeNosyaActiveKbn = kbn

        // 納車先詳細を入力させる
        const data = this.tmpIrekaeNosya[kbn].data
        this.tmpIrekaeNosya.data = data
        this.isShowNosyaDetailDialog = true

        this.isShowMasterDialog = false
        this.isShowDirectDialog = false
        this.isShowFavoriteDialog = false
        this.isShowIrekaeNosyaDialog = false
      }
    },

    addOperationLog(method, args = null) {
      this.operationLog.push({
        method: method,
        args: args ? cloneDeep(args) : null,
        syaryo: cloneDeep(this.syaryo),
        syaryos: cloneDeep(this.syaryos),
      })
    },

    onFileError(file) {
      this.removeFile(file)
      this.spinerOff()
      this.scroll('clear')
      this._alert('5MB以下のファイルを1ファイルのみご利用ください', false)
    },

    onOtherFileError(file) {
      this.removeOtherFile(file)
      this.spinerOff()
      this.scroll('clear')
      this._alert('5MB以下のファイルを5ファイル以下でご利用ください', false)
    },
  },

  mounted() {
    this.observer = this.$refs.observer
  },

  created: async function () {
    // formがない場合は発注ホーム画面に遷移
    this.form = this.$route.params.form
    this.addOperationLog('created', { form: this.form })

    if (!this.form) {
      return this.$router.push({ name: 'OrderIndex' })
    }
    this.$store.commit('vehicle/changeDisplayButtomElem', false)
    this.spinerOn()

    this.setSyaryoMaker()
    this.setNumberArea()
    this.getNumberPlateOkiniiri().then((res) => {
      this.transports = res.data
    })

    // デフォルト値設定
    await this.makeDefaultData()
    this.setDefaultData()

    // オプション入力済みデータ設定
    if (this.form.option) {
      this.option = cloneDeep(this.form.option)
    }

    // 車両入力済みデータ設定
    if (this.form.syaryos) {
      Store.commit('vehicle/destroy') // 車両リストを初期化
      for (const i in this.form.syaryos) {
        const syaryo = this.form.syaryos[i]
        // 履歴から編集(1車両しか存在しない)
        if (this.form._isFromHistoryEdit || this.form.isFromTrialEdit) {
          delete this.form._isFromHistoryEdit
          delete this.form.isFromTrialEdit
          syaryo.HANSYUTUKEN_URL = ''
          if (!Array.isArray(syaryo.OTHER_FILE_LIST)) {
            syaryo.OTHER_FILE_LIST = []
          }
          if (syaryo.TOUROKU_BANGO) {
            const torokuBango = syaryo.TOUROKU_BANGO.split(' ')
            syaryo.torokubango1 = torokuBango[0]
            syaryo.torokubango2 = torokuBango[1]
            syaryo.torokubango3 = torokuBango[2]
            syaryo.torokubango4 = torokuBango[3]
          }
          this.syaryo = this.syaryoDefaultMerge(syaryo)
        } else {
          if (
            this.form.syaryos.length > 1 ||
            (this.form.syaryos.length === 1 &&
              this.beforeRouteName !== 'OrderConfirm')
          ) {
            this._addVehicle(this.syaryoDefaultMerge(syaryo))
          } else {
            this.syaryo = this.syaryoDefaultMerge(syaryo)
            this.addFileToS3()
          }
        }
      }
    }

    if (this.isManySyaryos && this.beforeRouteName === 'OrderConfirm') {
      this.isForceShowSyaryoList = true
    }

    // リストに追加してない入力途中のデータ
    if (this.beforeRouteName !== 'OrderConfirm' && this.form.syaryo) {
      this.syaryo = this.form.syaryo
      this.addFileToS3()
    }

    if (this.syaryo.NUMBER_PLATE_TODO_CD) {
      this.nPCityList = await this.getCityList(this.syaryo.NUMBER_PLATE_TODO_CD)
      if (!this.syaryo.NUMBER_PLATE_SHIKU_CD) {
        this.setNPShikuCd(this.syaryo.NUMBER_PLATE_SHIKU_MEI)
      }
    }

    this.observer.reset()
    this.scroll('clear')
    this.spinerOff()
    this.$store.commit('vehicle/changeDisplayButtomElem')
  },

  computed: {
    /** 登録番号の項目全てを入力しているか判定 */
    isInputTorokuBnago() {
      return (
        this.syaryo.torokubango1 &&
        this.syaryo.torokubango2 &&
        this.syaryo.torokubango3 &&
        this.syaryo.torokubango4
      )
    },

    /** 登録番号の項目にエラーがあるか判定 */
    isInvalidTorokuBnago() {
      return (
        !this.syaryo.torokubango1 ||
        this.observer.fields.torokubango2.invalid ||
        this.observer.fields.torokubango3.invalid ||
        this.observer.fields.torokubango4.invalid
      )
    },

    /** 登録番号の項目全てが未入力か判定 */
    isEmptyTorokuBnago() {
      return (
        !this.syaryo.torokubango1 &&
        !this.syaryo.torokubango2 &&
        !this.syaryo.torokubango3 &&
        !this.syaryo.torokubango4
      )
    },

    /** 登録番号の入力が必須か判定 */
    isRequiredTorokuBnago() {
      return (
        !this.syaryo.SYADAI_BANGO ||
        (this.syaryo.SYADAI_BANGO &&
          !this.isInputTorokuBnago &&
          !this.isEmptyTorokuBnago)
      )
    },

    /** バリデーション実行済みか */
    isVlidated() {
      return this.observer && this.observer.flags.validated
    },

    /** 下取入れ替え車両を利用できるか */
    isIrekaePossible() {
      return (
        !this.isNosyaHarbor &&
        !this.isNosyaYard &&
        !Number(this.form.NOSYA_AA_FLG) &&
        !this.isIrekae &&
        !this.form.isFromHistoryEdit
      )
    },

    /** ナビの表示区分を返却 */
    naviMode() {
      let mode = 'default'
      if (this.form.isFromHistoryEdit || this.isListEdit) mode = 'edit'
      if (this.isIrekae) mode = 'irekae'
      return mode
    },

    // 引取で選択したタブ名取得
    hTab() {
      return this.form.ACTIVE_HIKITORI_TAB
    },

    // 納車で選択したタブ名取得
    nTab() {
      return this.form.ACTIVE_NOSYA_TAB
    },

    isHikitoriMaster() {
      return this.hTab === 'MASTER'
    },
    isHikitoriDirect() {
      return this.hTab === 'DIRECT'
    },
    isHikitoriFavorite() {
      return this.hTab === 'FAVORITE'
    },
    isNosyaMaster() {
      return this.nTab === 'MASTER'
    },
    isNosyaFavorite() {
      return this.nTab === 'FAVORITE'
    },
    isNosyaDirect() {
      return this.nTab === 'DIRECT'
    },
    isHikitoriAA() {
      return this.form.HIKITORI_AA_FLG
    },

    /** 納車先が港か */
    isNosyaHarbor() {
      return Number(this.nosya.LANDMARK_KBN) === 2
    },

    /** 納車先がオークション会場か */
    isNosyaAA() {
      return this.form.NOSYA_AA_FLG
    },

    /** 納車先 */
    nosya() {
      return this.form[`NOSYA_${this.nTab}`]
    },

    /** 納車ヤード判定 */
    isNosyaYard() {
      return this.nosya && this.nosya.YUSO_KBN === Constant.YUSOKBN.YARD
    },

    /** 納車保管ヤード判定 */
    isNosyaHokanYard() {
      if (!this.isLease) return false
      else if (this.isNosyaYard) return true
      else
        return (
          this.nosya.LANDMARK_KBN &&
          Constant.LANDMARK_YARD_VALUS.indexOf(
            Number(this.nosya.LANDMARK_KBN)
          ) >= 0
        )
    },
    syaryoDeleteId() {
      return Store.state.vehicle.deleteId
    },
    editSyaryoId() {
      return Store.state.vehicle.editId
    },
    addVecleFlg() {
      return Store.state.vehicle.addVecleFlg
    },
    isShowSyaryoList() {
      return Store.state.vehicle.isShowSyaryoList
    },
    nextConfirmFlg() {
      return Store.state.order.nextConfirmFlg
    },
    isManySyaryos() {
      return this.form.syaryos !== undefined && this.form.syaryos.length > 1
    },

    /** 請求可能な取引先か */
    isEnableInvoice() {
      return this.torihikiSaki.NAVI_SEIKYU_FLG
    },

    /** 長さ・幅・高さ が必須か */
    isRequiredNagasaHabaTakasa() {
      return (
        !this.isHikitoriAA && [5, 6, 7].includes(this.syaryo.SYARYO_TYPE_KBN)
      )
    },

    /** 積載量・重量か */
    isSyaryoTypeKbnTruck() {
      return [5, 6].includes(this.syaryo.SYARYO_TYPE_KBN)
    },

    /** 納車希望日種別 */
    nosyaKibouBiType() {
      return getYusouKibouBiTypeByValue(this.form.NOSYA_KIBOU_BI_TYPE).label
    },

    /** 納車希望時間 */
    nosyaKibouJikanType() {
      return getYusouKibouJikanTypeByValue(this.form.NOSYA_KIBOU_JIKAN_TYPE).label
    },
  },

  watch: {
    /** 入れ替えフラグ監視 */
    isIrekae(val) {
      if (val || (!val && this.isListEdit)) this.hideButtomList()
      else this.showButtomList()
    },

    isShowSyaryoList(val) {
      this.isForceShowSyaryoList = val
    },
    isForceShowSyaryoList() {
      Store.commit('vehicle/setIsShowSyaryoList', this.isForceShowSyaryoList)
    },
    // addVecleFlg () {
    //  if (this.isForceShowSyaryoList) this.isForceShowSyaryoList = false
    //  this.beforeAddVehicles()
    // },
    // 確認画面へ遷移(下部の発注車両リスト中の次へを押した時に発火)
    nextConfirmFlg() {
      this.beforeNext(this.isForceShowSyaryoList)
      if (this.isForceShowSyaryoList) this.isForceShowSyaryoList = false
    },
    syaryoDeleteId(id) {
      this.deleteSyaryo(id)
      if (this.isForceShowSyaryoList) this.isForceShowSyaryoList = false
    },
    editSyaryoId(id) {
      if (id !== '') {
        this.isForceShowSyaryoList || this.isErrSyaryoList
          ? this.editSyaryo()
          : (this.isEditSyaryoListConfirm = true)
        if (this.isForceShowSyaryoList) this.isForceShowSyaryoList = false
      }
      if (this.isErrSyaryoList) this.isErrSyaryoList = false
    },
    isListEdit(val) {
      this.$store.commit('vehicle/changeDisplayButtomElem', !val)
    },
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.beforeRouteName = from.name
    })
  },
}
</script>

<style lang="sass" scoped>
@import '../../../assets/css/logico2'
.border-red-dialog
  border: 5px solid $baseRedColor !important
#dropzone
  width: 50%
  @include sp
    width: 100%
.section-wrapper
  background: $baseGrayColor
  padding: 1%
section.irekae-nosya,
section.order-syaryo,
section.order-hannyu,
section.order-jyotai,
section.order-biko,
section.order-option,
section.order-seikyu
  table
    th
      background: $baseBlueColor
      color: #fff
      width: 32%
      padding: 1.5%
    td
      width: 68%
      background: #fff
.add-vehicle-wrapper .another-add
  button
    background: orange !important
    color: white !important
    height: 60px
    font-size: 28px
    &:hover
      opacity: 0.8
    @include sp
      font-size: 20px
      height: 50px
</style>



// WEBPACK FOOTER //
// src/components/order/default/Vehicle.vue